"use strict";

document.getElementById('svg-container').innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" style="width:0;height:0" visibility="hidden"><defs><linearGradient id="paint0_linear" x1="31" y1="1" x2="31" y2="23" gradientUnits="userSpaceOnUse"><stop stop-color="#1C4672"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient><filter id="filter0_i" x=".439" y=".239" width="18.478" height="19.478" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/><feColorMatrix values="0 0 0 0 0.447083 0 0 0 0 0.537287 0 0 0 0 0.616667 0 0 0 0.6 0"/><feBlend in2="shape" result="effect1_innerShadow"/></filter><filter id="filter0_i" x=".999" y=".797" width="18.038" height="21.204" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy=".761"/><feGaussianBlur stdDeviation=".57"/><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/><feColorMatrix values="0 0 0 0 0.447083 0 0 0 0 0.537287 0 0 0 0 0.616667 0 0 0 1 0"/><feBlend in2="shape" result="effect1_innerShadow"/></filter><filter id="filter0_i" x=".288" y=".042" width="9.697" height="22.566" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="1"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/><feColorMatrix values="0 0 0 0 0.447083 0 0 0 0 0.537287 0 0 0 0 0.616667 0 0 0 1 0"/><feBlend in2="shape" result="effect1_innerShadow"/></filter><filter id="filter1_i" x="10.235" y=".042" width="9.697" height="22.566" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="1"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/><feColorMatrix values="0 0 0 0 0.447083 0 0 0 0 0.537287 0 0 0 0 0.616667 0 0 0 1 0"/><feBlend in2="shape" result="effect1_innerShadow"/></filter></defs><symbol id="svg-arr-down" viewBox="0 0 200 200"><path d="M200 71.9L100 172.1 0 71.9"/></symbol><symbol id="svg-arr-right" viewBox="0 0 200 200"><path d="M99.9 0L200 100 99.9 200M0 100h200"/></symbol><symbol id="svg-arrow-down" viewBox="0 0 12 7"><path d="M1 1l5 5 5-5" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></symbol><symbol id="svg-icon-360" viewBox="0 0 62 27"><path d="M61.5 12c0 1.313-.749 2.633-2.258 3.899-1.506 1.263-3.715 2.424-6.489 3.408C47.21 21.274 39.52 22.5 31 22.5s-16.21-1.226-21.753-3.193c-2.774-.984-4.983-2.145-6.49-3.408C1.25 14.633.5 13.313.5 12c0-1.313.749-2.633 2.257-3.899 1.507-1.263 3.716-2.424 6.49-3.408C14.79 2.726 22.48 1.5 31 1.5s16.21 1.226 21.753 3.193c2.774.984 4.983 2.145 6.49 3.408C60.75 9.367 61.5 10.687 61.5 12z" stroke="#6C8EB1"/><path d="M61.5 12c0 1.313-.749 2.633-2.258 3.899-1.506 1.263-3.715 2.424-6.489 3.408C47.21 21.274 39.52 22.5 31 22.5s-16.21-1.226-21.753-3.193c-2.774-.984-4.983-2.145-6.49-3.408C1.25 14.633.5 13.313.5 12c0-1.313.749-2.633 2.257-3.899 1.507-1.263 3.716-2.424 6.49-3.408C14.79 2.726 22.48 1.5 31 1.5s16.21 1.226 21.753 3.193c2.774.984 4.983 2.145 6.49 3.408C60.75 9.367 61.5 10.687 61.5 12z" stroke="url(#paint0_linear)"/><path d="M22 22.329L26.329 18v8.657L22 22.33zM39.657 22.329L35.33 18v8.657l4.328-4.328zM23.06 10.4c1.027.056 1.806.336 2.338.84.541.495.812 1.143.812 1.946 0 .56-.135 1.06-.406 1.498-.27.43-.672.77-1.204 1.022-.532.252-1.18.378-1.946.378-.71 0-1.381-.112-2.016-.336-.625-.233-1.13-.541-1.512-.924l.49-.798c.327.336.76.611 1.302.826.541.205 1.12.308 1.736.308.803 0 1.423-.173 1.862-.518.439-.355.658-.84.658-1.456 0-.607-.22-1.083-.658-1.428-.439-.345-1.101-.518-1.988-.518h-.7v-.742l2.716-3.402h-5.012V6.2h6.3v.714L23.06 10.4zm8.63-.266c.644 0 1.214.121 1.708.364.504.243.896.588 1.176 1.036.28.439.42.952.42 1.54 0 .597-.144 1.125-.434 1.582-.289.457-.69.812-1.204 1.064-.504.243-1.073.364-1.708.364-1.297 0-2.291-.425-2.982-1.274-.69-.859-1.036-2.067-1.036-3.626 0-1.092.187-2.016.56-2.772.374-.756.896-1.325 1.568-1.708.672-.392 1.456-.588 2.352-.588.971 0 1.746.177 2.324.532l-.406.812c-.466-.308-1.101-.462-1.904-.462-1.082 0-1.932.345-2.548 1.036-.616.681-.924 1.675-.924 2.982 0 .233.014.5.042.798.243-.532.63-.943 1.162-1.232.532-.299 1.144-.448 1.834-.448zm-.084 5.096c.71 0 1.284-.191 1.722-.574.448-.392.672-.91.672-1.554s-.224-1.157-.672-1.54c-.438-.383-1.036-.574-1.792-.574-.494 0-.933.093-1.316.28a2.217 2.217 0 0 0-.882.77c-.214.327-.322.69-.322 1.092 0 .373.098.719.294 1.036.206.317.504.574.896.77.392.196.859.294 1.4.294zm8.462.854c-.756 0-1.433-.2-2.03-.602-.588-.401-1.05-.975-1.386-1.722-.327-.756-.49-1.643-.49-2.66 0-1.017.163-1.9.49-2.646.336-.756.798-1.335 1.386-1.736a3.556 3.556 0 0 1 2.03-.602c.756 0 1.428.2 2.016.602.597.401 1.064.98 1.4 1.736.336.747.504 1.629.504 2.646s-.168 1.904-.504 2.66c-.336.747-.803 1.32-1.4 1.722-.588.401-1.26.602-2.016.602zm0-.924c.569 0 1.068-.159 1.498-.476.438-.317.779-.78 1.022-1.386.242-.607.364-1.34.364-2.198 0-.859-.122-1.591-.364-2.198-.243-.607-.584-1.069-1.022-1.386a2.452 2.452 0 0 0-1.498-.476c-.57 0-1.074.159-1.512.476-.43.317-.766.78-1.008 1.386-.243.607-.364 1.34-.364 2.198 0 .859.12 1.591.364 2.198.242.607.578 1.069 1.008 1.386.438.317.942.476 1.512.476zm7.616-4.592a2.181 2.181 0 0 1-2.226-2.226c0-.401.098-.77.294-1.106a2.15 2.15 0 0 1 .798-.812 2.258 2.258 0 0 1 1.134-.294c.41 0 .788.098 1.134.294.345.196.616.467.812.812.196.336.294.705.294 1.106 0 .41-.098.789-.294 1.134a2.151 2.151 0 0 1-.812.798 2.258 2.258 0 0 1-1.134.294zm0-.588c.457 0 .84-.154 1.148-.462.317-.317.476-.71.476-1.176 0-.457-.159-.84-.476-1.148a1.535 1.535 0 0 0-1.148-.476c-.457 0-.84.159-1.148.476-.308.308-.462.69-.462 1.148 0 .467.154.859.462 1.176.308.308.69.462 1.148.462z" fill="#6C8EB1"/></symbol><symbol id="svg-icon-burger" viewBox="0 0 30 14"><rect width="30" height="2" rx="1" fill="#DB2852"/><rect y="12" width="30" height="2" rx="1" fill="#DB2852"/><rect x="10" y="6" width="20" height="2" rx="1" fill="#DB2852"/></symbol><symbol id="svg-icon-close" viewBox="0 0 13 13"><path transform="rotate(-45 0 .707)" fill="#48729E" d="M0 .707h1v16H0z"/><path transform="rotate(45 11.314 0)" fill="#48729E" d="M11.314 0h1v16h-1z"/></symbol><symbol id="svg-icon-feature-1" viewBox="0 0 30 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.635 1.94L15.08.28l-.554 1.66-1.567-.782.783 1.567-1.661.554 1.66.555L12.96 5.4l1.567-.783.554 1.661.555-1.661 1.566.783-.782-1.567 1.661-.555-1.661-.554.782-1.567-1.566.783zM4.275 20.86l-.555-1.662-.555 1.661-1.566-.782.782 1.566-1.661.555 1.661.554L1.6 24.32l1.566-.782.555 1.66.554-1.66 1.567.782-.783-1.567 1.661-.554-1.66-.555.782-1.566-1.567.782zm22.323-1.662l.555 1.661 1.566-.782-.782 1.566 1.661.555-1.661.554.782 1.567-1.566-.782-.555 1.66-.554-1.66-1.567.782.783-1.567-1.662-.554 1.662-.555-.783-1.566 1.567.782.554-1.66zm-4.53-3.956a6.887 6.887 0 1 1-13.773 0 6.887 6.887 0 0 1 13.774 0zm-10.895-.224a.585.585 0 0 1 .828 0l1.991 1.992 4.397-4.397a.585.585 0 1 1 .827.827l-4.81 4.81-.414.414-.414-.414-2.404-2.405a.585.585 0 0 1 0-.827z" fill="#fff"/></symbol><symbol id="svg-icon-feature-2" viewBox="0 0 19 19"><path d="M18.192 16.723c-.33.28-.689.523-1.07.726l-.675.326c-1.486.627-3.433.943-5.823.943-.396 0-.805-.01-1.227-.027a36.914 36.914 0 0 1-5.636-.687C1.276 17.409.44 16.543.44 14.574V2.739a.315.315 0 0 1 .201-.293L6.492.258a.304.304 0 0 1 .382.154l1.54 3.124a.316.316 0 0 1-.03.327L6.537 6.362a.308.308 0 0 1-.312.118L4.52 6.115a.076.076 0 0 0-.087.102 30.33 30.33 0 0 1 1.571 5.694c.01.057.078.083.123.047 1.105-.865 3.05-2.064 5.395-2.094a7.168 7.168 0 0 1 4.364 1.444 3.59 3.59 0 0 1 1.25-.83c.47-.184.971-.267 1.474-.242.082 0 .16.033.218.091a.315.315 0 0 1 0 .442L18.3 16.51a.314.314 0 0 1-.108.212z" fill="#fff" filter="url(#filter0_i)"/></symbol><symbol id="svg-icon-feature-3" viewBox="0 0 20 22"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.836.852C8.802 1.54 6.1 2.89 2.872 3.202c-4.13.399-1.264 13.931 6.957 17.994a.427.427 0 0 0 .378 0c8.221-4.063 11.087-17.595 6.957-17.994-3.227-.312-5.93-1.662-6.964-2.35a.327.327 0 0 0-.364 0zm-1.9 9.625a.76.76 0 1 0-1.076 1.076l1.808 1.807.538.538.537-.538 3.615-3.615a.76.76 0 1 0-1.075-1.075l-3.077 3.077-1.27-1.27z" fill="#fff" filter="url(#filter0_i)"/></symbol><symbol id="svg-icon-feature-4" viewBox="0 0 20 22"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.752 1.15l.41.273-.368.327c-.433.384-.385.93-.306 1.147a.38.38 0 0 1-.715.26c-.118-.326-.204-1.033.223-1.647a2.676 2.676 0 0 1-.578-.817A2.338 2.338 0 0 1 7.312.41a1.774 1.774 0 0 0-.624.415C4.402.12 4.125 1.649 4.272 2.5c-1.118.043-1.479 1.367-1.52 2.023-1.464.957-1.146 2.58-.804 3.27-.994.375-.709 1.192-.442 1.553-1.131.7-.995 1.815-.785 2.285-1.009 1.67-.002 2.866.46 3.415.122.144.206.244.205.295-.318 1.484.295 2.403.924 2.882.257.016.6-.047.871-.339l.335-.361.265.415c.127.2.393.486.753.657.346.164.782.226 1.3-.006a.38.38 0 1 1 .312.694c-.743.332-1.413.248-1.938-.001a2.675 2.675 0 0 1-.804-.595 1.743 1.743 0 0 1-.358.183c.573 1.764 2.16 1.85 2.92 1.657 1.41 1.737 3.266.997 4.017.409v-7.873a.386.386 0 0 1-.279-.24 2.581 2.581 0 0 0-.75-1.043c-.355-.283-.809-.437-1.391-.235l-.456.158-.05-.482a.538.538 0 0 0-.158-.327c-.067-.06-.208-.14-.524-.056-.243.105-.644.207-1.014.055a.946.946 0 0 1-.5-.482c-.108-.228-.147-.507-.13-.833a.375.375 0 0 1 .401-.354c.21.015.37.196.359.406-.014.248.021.388.056.461.03.064.064.086.095.099.094.038.271.02.437-.057l.026-.013.028-.008c.536-.152.968-.051 1.269.218.132.118.226.257.29.395.697-.122 1.285.107 1.731.461.22.175.408.381.561.59v-7.93L9.986.316c-.73-.383-.996-.285-1.31-.17-.165.062-.342.127-.606.13a1.911 1.911 0 0 0 .684.874z" fill="#fff" filter="url(#filter0_i)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.344 1.15l-.41.273.368.327c.433.384.385.93.306 1.147a.38.38 0 1 0 .715.26c.118-.326.204-1.033-.223-1.647.213-.207.428-.483.578-.817.047-.103.087-.212.118-.326.36.12.623.33.736.457 2.286-.703 2.563.825 2.416 1.677 1.118.043 1.479 1.367 1.52 2.023 1.465.957 1.146 2.58.804 3.27.994.375.709 1.192.442 1.553 1.131.7.995 1.815.785 2.285 1.009 1.67.002 2.866-.46 3.415-.122.144-.206.244-.205.295.318 1.484-.295 2.404-.924 2.882a1.073 1.073 0 0 1-.866-.339l-.336-.361-.264.415c-.127.2-.394.486-.754.657-.346.164-.782.226-1.3-.006a.38.38 0 1 0-.311.694c.743.332 1.413.248 1.937-.001.331-.157.602-.378.804-.595.116.077.235.137.354.181-.572 1.766-2.16 1.852-2.92 1.659-1.41 1.737-3.266.997-4.017.409v-7.874a.386.386 0 0 0 .279-.24c.117-.309.376-.746.75-1.043.355-.282.809-.436 1.391-.234l.456.158.05-.483a.537.537 0 0 1 .158-.326c.067-.06.208-.14.524-.057.243.106.644.208 1.014.056a.946.946 0 0 0 .5-.483c.108-.227.147-.506.13-.832a.375.375 0 0 0-.401-.354.386.386 0 0 0-.359.405c.014.248-.021.388-.056.462-.03.063-.064.086-.095.098-.094.04-.271.02-.437-.056l-.026-.013-.028-.008c-.536-.152-.968-.052-1.269.217a1.222 1.222 0 0 0-.29.396c-.697-.122-1.285.107-1.731.46-.22.176-.408.382-.56.591l-.002-7.93V.316c.73-.383.996-.285 1.31-.17.138.052.285.106.485.124-.014.039-.03.076-.046.113a1.912 1.912 0 0 1-.64.767z" fill="#fff" filter="url(#filter1_i)"/></symbol><symbol id="svg-link-arrow" viewBox="0 0 5 8"><path transform="rotate(-45 0 .707)" d="M0 .707h1v5H0z"/><path transform="rotate(-135 .707 7.071)" d="M.707 7.071h1v5h-1z"/></symbol><symbol id="svg-menu" viewBox="0 0 200 200"><path class="burger__line burger__line--1" d="M0 100h200"/><path class="burger__line burger__line--2" d="M0 100h200"/><path class="burger__line burger__line--3" d="M0 100h200"/></symbol><symbol id="svg-plus" viewBox="0 0 200 200"><path d="M100 0v200M200 100H0"/></symbol><symbol id="svg-search" viewBox="0 0 18 18"><path d="M8.25 14.25a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM15.75 15.75l-3.262-3.262" stroke="#211E20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></symbol></svg>';
/* globals Raven */

/* eslint moduleName:0 */
"use strict";

(function () {
  var itsoftApp;
  var pageHeader = document.querySelector(".page-header");
  var slice = [].slice;
  /* Полифилы */

  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  (function (ELEMENT) {
    ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;

    ELEMENT.closest = ELEMENT.closest || function closest(selector) {
      if (!this) return null;
      if (this.matches(selector)) return this;

      if (!this.parentElement) {
        return null;
      } else return this.parentElement.closest(selector);
    };
  })(Element.prototype); // Hack for IE <= 8


  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (elt) {
      var len = this.length >>> 0;
      var from = Number(arguments[1]) || 0;
      from = from < 0 ? Math.ceil(from) : Math.floor(from);

      if (from < 0) {
        from += len;
      }

      for (; from < len; from++) {
        if (from in this && this[from] === elt) {
          return from;
        }
      }

      return -1;
    };
  }

  window.itsoftApp = itsoftApp = {
    createNS: function createNS(namespace) {
      var i, len, nsparts, parent, part;
      nsparts = namespace.split(".");
      parent = itsoftApp; // we want to be able to include or exclude the root namespace so we strip
      // it if it's in the namespace

      if (nsparts[0] === "itsoftApp") {
        nsparts = nsparts.slice(1);
      } // loop through the parts and create a nested namespace if necessary


      for (i = 0, len = nsparts.length; i < len; i++) {
        part = nsparts[i]; // check if the current parent already has the namespace declared
        // if it isn't, then create it

        if (typeof parent[part] === "undefined") {
          parent[part] = {};
        } // get a reference to the deepest element in the hierarchy so far


        parent = parent[part];
      }

      return parent;
    },
    isLocal: !!document.getElementById("js-server-local"),
    utils: {
      debouncer: function debouncer(func, timeout) {
        var timeoutID;

        if (timeout == null) {
          timeout = 200;
        }

        timeoutID = undefined;
        return function () {
          var args, scope;
          scope = this;
          args = arguments;
          clearTimeout(timeoutID);
          timeoutID = setTimeout(function () {
            func.apply(scope, Array.prototype.slice.call(args));
          }, timeout);
        };
      },
      // Stealed from
      // https://github.com/VodkaBears/Remodal
      getScrollbarWidth: function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
      },
      // TODO
      // REPAINT
      // Вызывает Recalculate Style
      // Проверить, из-за чего, и можно ли избавиться
      getScrTop: function getScrTop() {
        var $body, $document, $wrapper, scrTop;
        $document = itsoftApp.commonVars.$document;
        $body = itsoftApp.commonVars.$body;
        $wrapper = itsoftApp.commonVars.$wrapper;
        scrTop = Math.max($document.scrollTop, $body.scrollTop, $wrapper.scrollTop, 0); // console.log($document.scrollTop(), $body.scrollTop(), $wrapper.scrollTop())

        return scrTop;
      },
      getTime: function () {
        var res;

        if (window.performance && typeof window.performance.now === "function") {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }

            return parseFloat(window.performance.now().toFixed(precision));
          };
        } else {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }

            return parseFloat(new Date().getTime().toFixed(precision));
          };
        }

        return res;
      }(),
      newMeasureFunc: function newMeasureFunc(precision) {
        var res, t0;

        if (precision == null) {
          precision = 2;
        }

        t0 = itsoftApp.utils.getTime(precision);

        res = function res() {
          var t1, t2;
          t1 = itsoftApp.utils.getTime(precision);
          t2 = parseFloat((t1 - t0).toFixed(precision));
          t0 = t1;
          return t2;
        };

        return res;
      },
      getInitTimes: function getInitTimes() {
        var k, module, obj, ref, total;
        obj = {};
        total = 0;
        ref = itsoftApp.modules;

        for (k in ref) {
          module = ref[k];

          if (module.initialized && module.__mName__ !== undefined) {
            obj[module.__mName__] = module.__initTime__;
            total += module.__initTime__;
          }
        }

        obj.all = Math.round(total);
        return obj;
      },
      checkIsSafari: function checkIsSafari() {
        var UA = navigator.userAgent.toLowerCase();

        if (UA.indexOf('safari') != -1) {
          if (UA.indexOf('chrome') > -1) {
            return;
          } else {
            return true;
          }
        }
      },
      getViewportSize: function getViewportSize() {
        if (itsoftApp.utils.checkIsSafari()) {
          return document.documentElement.clientWidth;
        } else {
          return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        }
      },
      getHeaderHeight: function getHeaderHeight() {
        itsoftApp.commonVars.headerHeight = pageHeader.offsetHeight;
        return itsoftApp.commonVars.headerHeight;
      }
    },
    loadScript: function loadScript(url, callback, error) {
      var script;
      script = document.createElement("script"); // If "fallback" url passed as second argument

      var args = Array.prototype.slice.call(arguments);

      if (typeof callback === "string") {
        var fallbackUrl = callback;
        callback = error;
        var errorOri = args[3];

        error = function error() {
          DEBUG && console.log("%c[common] error while loading script: " + url + ". trying to load a fallback url: " + fallbackUrl, "color: red");
          itsoftApp.loadScript(fallbackUrl, callback, errorOri);

          if (!DEBUG && typeof Raven !== "undefined") {
            Raven.captureMessage("[common] error while loading script", {
              level: "warning",
              // one of 'info', 'warning', or 'error'
              extra: {
                "script": url,
                "fallback": fallbackUrl
              }
            });
          }
        };
      }

      var cb = function cb() {
        DEBUG && console.log("%c--[common] finished loading script: " + url, "color: #999");

        if (typeof callback === "function") {
          callback();
        }
      }; // IE


      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState === "loaded" || script.readyState === "complete") {
            script.onreadystatechange = null;
            cb();
          }
        }; // Normal browsers

      } else {
        if (typeof error === "function") {
          script.onerror = error;
        }

        script.onload = cb;
      }

      script.src = url;
      document.getElementsByTagName("body")[0].appendChild(script);
      DEBUG && console.log("%c--[common] starting to load script: " + url, "color: #999");
    },
    loadStyle: function loadStyle(url) {
      var first, head, link;
      link = document.createElement("link");
      link.href = url;
      link.rel = "stylesheet";
      link.type = "text/css";
      head = document.getElementsByTagName("head")[0];
      first = head.firstChild; // Prepend styles in 'head' section

      head.insertBefore(link, first);
    },
    features: {
      // From Modernizr
      transitionEventEnd: function () {
        var el, t, transitions;
        el = document.createElement("fakeelement");
        transitions = {
          "transition": "transitionend",
          "OTransition": "oTransitionEnd",
          "MozTransition": "transitionend",
          "WebkitTransition": "webkitTransitionEnd"
        };

        for (t in transitions) {
          if (el.style[t] !== undefined) {
            el = null;
            return transitions[t];
          }
        }

        return false;
      }()
    },
    modules: {},
    initializedModules: [],
    createModule: function createModule() {
      var dep, dependencies, i, initFunc, j, len, mName, module, options, ref;
      mName = arguments[0], options = 3 <= arguments.length ? slice.call(arguments, 1, i = arguments.length - 1) : (i = 1, []), initFunc = arguments[i++];

      if (typeof initFunc !== "function") {
        throw "Missing an initialization function for module '" + mName + "'";
      } // Create a namespace


      module = itsoftApp.createNS("modules." + mName);
      module.__mName__ = mName;
      module.initialized = false; // Set dependencies

      if (options.length && options[0].length) {
        dependencies = [];
        ref = options[0];

        for (j = 0, len = ref.length; j < len; j++) {
          dep = ref[j];

          if (typeof dep === "string" && dependencies.indexOf(dep) < 0 && dep !== mName) {
            dependencies.push(dep);
          }
        }

        if (dependencies.length) {
          module.dependencies = dependencies;
        }
      } // Set initialization function and behavior


      module.init = function () {
        var depModule, e, initTime, initializedModules, l, len1, t1, t2;

        try {
          if (module.dependencies) {
            for (l = 0, len1 = dependencies.length; l < len1; l++) {
              dep = dependencies[l];
              depModule = itsoftApp.modules[dep];

              if (!depModule) {
                DEBUG && console.log("%c[modules] missed module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }

              if (depModule.initialized) {
                continue;
              }

              depModule.init();

              if (!depModule.initialized) {
                DEBUG && console.log("%c[modules] can't init module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }
            }
          }

          t1 = itsoftApp.utils.getTime();

          if (initFunc.call(module) !== false) {
            t2 = itsoftApp.utils.getTime();
            initTime = parseFloat((t2 - t1).toFixed(1));
            module.__initTime__ = initTime;
            DEBUG && console.log("[module " + mName + "] module initialized in " + initTime + " ms");
            module.initialized = true;
            initializedModules = itsoftApp.initializedModules || [];
            initializedModules.push(mName);
            itsoftApp.initializedModules = initializedModules;
          }
        } catch (error1) {
          e = error1;

          if (typeof Raven !== "undefined") {
            Raven.captureException(e);
          }

          itsoftApp.errorHandler(e, {
            moduleName: mName
          });
        }
      };

      return module;
    },
    errorHandler: function errorHandler(error, options) {
      var pre;
      pre = "[error]";

      if (options && options.moduleName) {
        pre += "[module " + options.moduleName + "]";
      }

      if (console && console.error) {
        console.error(pre + "\n" + error + "\nNavigator: " + window.navigator.userAgent);
      }
    }
  }; // Unit-tests for itsoftApp object

  if (DEBUG && typeof mocha !== "undefined" && typeof describe === "function") {
    mocha.setup("bdd");
    describe("itsoftApp object tests", function () {
      it("Should be an object", function () {
        expect(itsoftApp).to.be.an("object");
      });
      it("Should contain a loadScript function", function () {
        expect(itsoftApp.loadScript).to.be.a("function");
      });
      it("Should contain a loadStyle function", function () {
        expect(itsoftApp.loadStyle).to.be.a("function");
      });
      it("We can create a deep namespace scope with a string like 'ns1.ns2.ns3'", function () {
        itsoftApp.createNS("ns1.ns2.ns3");
        expect(itsoftApp.ns1).to.be.an("object");
        expect(itsoftApp.ns1.ns2).to.be.an("object");
        expect(itsoftApp.ns1.ns2.ns3).to.be.an("object");
        delete itsoftApp.ns1;
      });
      it("initializedModules must be defined from the start", function () {
        expect(itsoftApp.initializedModules).to.be.an("array");
      });
      describe(".modules", function () {
        it("Should be a function to create modules", function () {
          expect(itsoftApp.createModule).to.be.a("function");
        });
        it("We can simply create a single module", function () {
          var module, testFunc;

          testFunc = function testFunc() {
            console.log("test module init");
          };

          var mName = "testmodule" + Math.round(Math.random() * 100);
          module = itsoftApp.createModule(mName, testFunc);
          expect(module).to.be.equal(itsoftApp.modules[mName]);
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
        it("We can't create a module without initialization function", function () {
          var module;

          module = function module() {
            itsoftApp.createModule("testmodule");
          };

          expect(module).to["throw"];
        });
        it("Each module must have an init function", function () {
          var module;

          for (module in itsoftApp.modules) {
            expect(itsoftApp.modules[module].init).to.be.a("function");
          }
        });
        it("Should throw an exception if we try to initialize a module twice", function () {
          var mName, module, testFunc;
          mName = "testmodule" + Math.round(Math.random() * 100);

          testFunc = function testFunc() {
            return 1;
          };

          module = itsoftApp.createModule(mName, testFunc);
          module.init();
          expect(module.init).to["throw"];
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
      });
    });
  }

  var itsoftAppInitFunc = function itsoftAppInitFunc() {
    var init = function init() {
      itsoftApp.commonVars = {
        $document: document.documentElement,
        $body: document.body,
        $window: window,
        $wrapper: document.querySelector(".l-wrapper"),
        headerHeight: undefined
      };
      var benchmarkCloseBtn, benchmarkDiv, criticalInitTime, dColor, fTime, initTimes, m, module, moduleName, t, time, warningModules;

      if (DEBUG) {
        t = itsoftApp.utils.getTime();
      }

      itsoftApp.ajaxDisabled = false; //нужно для работы с аяксовыми переходами.

      itsoftApp.removeAllModules = function () {
        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];
          module.initialized = false;
        }

        itsoftApp.initializedModules = [];
        DEBUG && console.log("%c[common] all modules removed", "font-weight: bold;");
      };

      itsoftApp.initAllModules = function () {
        // Initialize itsoftApp modules
        itsoftApp.removeAllModules();

        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];

          if (!module.initialized && typeof module.init === "function") {
            module.init();
          }
        }
      };

      itsoftApp.initAllModules();

      if (DEBUG) {
        fTime = Math.round(itsoftApp.utils.getTime() - t);
        dColor = fTime < 200 ? "green" : "red";
        console.log("%c[common] document ready event fired, " + itsoftApp.initializedModules.length + " modules initialized in " + fTime + " ms: " + function () {
          var i, len, ref, results;
          ref = itsoftApp.initializedModules;
          results = [];

          for (i = 0, len = ref.length; i < len; i++) {
            m = ref[i];
            results.push(" " + m + "(" + itsoftApp.modules[m].__initTime__ + "ms)");
          }

          return results;
        }(), "color: " + dColor);
      } // Add benchmark div


      benchmarkDiv = document.getElementById("benchmark");

      if (typeof itsoftApp.utils.getInitTimes === "function" && (DEBUG || window.location.hash === "#benchmark") && !benchmarkDiv) {
        benchmarkDiv = document.createElement("div");
        benchmarkDiv.className = "benchmark";
        benchmarkDiv.id = "benchmark";

        if (typeof itsoftApp.utils.getInitTimes === "function") {
          benchmarkDiv.innerHTML = "<small style=\"opacity: 0.7\">modules (ms):" + function () {
            var ref, results;
            ref = itsoftApp.utils.getInitTimes();
            results = [];

            for (m in ref) {
              t = ref[m];
              results.push(" " + m + ": " + t);
            }

            return results;
          }() + "</small>";
        } // Add close button


        benchmarkCloseBtn = document.createElement("a");

        benchmarkCloseBtn.onclick = function () {
          benchmarkDiv.parentNode.removeChild(benchmarkDiv);
        };

        benchmarkCloseBtn.innerHTML = "X";
        benchmarkCloseBtn.className = "benchmark__close";
        benchmarkDiv.appendChild(benchmarkCloseBtn);
        document.body.appendChild(benchmarkDiv);
      } // Check for "too complex" modules
      // WARNING иногда такие "ошибки" возникают спонтанно
      // (например, все модули инициализируются за 0-2 мс, а один "выстрелил" на 300 мс).
      // Если это станет мешать проектам, то можно данные предупреждения
      // из логгера убрать.


      if (!DEBUG && typeof Raven !== "undefined") {
        initTimes = itsoftApp.utils.getInitTimes();
        warningModules = [];
        criticalInitTime = 50;

        for (moduleName in initTimes) {
          time = initTimes[moduleName];

          if (moduleName === "all") {
            continue;
          }

          if (time > criticalInitTime) {
            warningModules.push(moduleName);
          }
        } //  CHANGED: Вот именно из-за того, что один из модулей может
        //  случайно инициализироваться за какое-то неадекватно большое для него время.
        //  if warningModules.length > 0


        if (warningModules.length > 1) {
          Raven.captureMessage("[common] detected some \"long\" (initTime > " + criticalInitTime + " ms) modules", {
            level: "warning",
            // one of 'info', 'warning', or 'error'
            extra: initTimes
          });
        }
      } // If unit tests library loaded, just load a file with tests


      if (typeof mocha !== "undefined") {
        mocha.setup("bdd");
        mocha.run();
      }
    };

    if ("addEventListener" in document) {
      init();
    }
  }; // Document ready event


  if ("addEventListener" in document) {
    document.addEventListener("DOMContentLoaded", itsoftAppInitFunc, false); // .. IE <= 8
  } else if ("attachEvent" in document) {
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState === "complete") {
        itsoftAppInitFunc();
      }
    });
  }
})();
"use strict";

itsoftApp.createModule("accordion", function () {
  var module = this;

  var initAccordions = function initAccordions(accordion) {
    var accordionHeadElements = accordion.querySelectorAll(".js-accordion-head");
    Array.prototype.forEach.call(accordionHeadElements, function (el) {
      el.addEventListener("click", function (evt) {
        evt.preventDefault();
        var self = this;
        var activeHead;
        var currentHead; // стили находятся в файле assets/styles/page.styl

        var closeAccordion = function closeAccordion(el) {
          if (self.classList.contains("js-accordion-head--parent")) {
            // находим родителя активного элемента
            var parent = el;
            var accordionItem = el.closest(".js-accordion-item");
            var nextElement = parent.nextElementSibling; // добавляем класс для анимации отображения/скрытия

            parent.classList.add("js-accordion-parent--ready");
            var height = nextElement.clientHeight + "px";
            nextElement.style.height = height;

            var _onTransitionEnd2 = function onTransitionEnd() {
              // удаляем у активного элемента активный класс
              activeHead.classList.remove("js-accordion-head--active");
              accordionItem.classList.remove("js-accordion-item--active"); // у родителя тоже

              parent.classList.remove("js-accordion-parent--active");
              parent.classList.remove("js-accordion-parent--ready");
              nextElement.removeEventListener("transitionend", _onTransitionEnd2);
            };

            nextElement.addEventListener("transitionend", _onTransitionEnd2);
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                // добавляем для соседнего элемента с контентом нулевую высоту
                nextElement.style.height = "0px";
              });
            });
          } else {
            var nextElement = activeHead.nextElementSibling;
            var accordionItem = activeHead.closest(".js-accordion-item");
            activeHead.classList.add("js-accordion-head--ready");
            var height = nextElement.clientHeight + "px";
            nextElement.style.height = height;

            var _onTransitionEnd2 = function _onTransitionEnd() {
              accordionItem.classList.remove("js-accordion-item--active");
              activeHead.classList.remove("js-accordion-head--ready");
              activeHead.classList.remove("js-accordion-head--active");
              nextElement.removeEventListener("transitionend", _onTransitionEnd2);
            };

            nextElement.addEventListener("transitionend", _onTransitionEnd2);
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                nextElement.style.height = "0px";
              });
            });
          }
        };

        var openAccordion = function openAccordion(el) {
          if (self.classList.contains("js-accordion-head--parent")) {
            var parent = el;
            var accordionItem = el.closest(".js-accordion-item");
            var nextElement = el.nextElementSibling;
            currentHead.classList.add("js-accordion-head--active");
            parent.classList.add("js-accordion-parent--active");
            accordionItem.classList.add("js-accordion-item--active");
            nextElement.style.height = "auto";
            var height = nextElement.clientHeight + "px";
            nextElement.style.height = "0px";
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                nextElement.style.height = height;
              });
            });
          } else {
            var nextElement = currentHead.nextElementSibling;
            var accordionItem = currentHead.closest(".js-accordion-item");
            currentHead.classList.add("js-accordion-head--active");
            accordionItem.classList.add("js-accordion-item--active");
            nextElement.style.height = "auto";
            var height = nextElement.clientHeight + "px";
            nextElement.style.height = "0px";
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                nextElement.style.height = height;
              });
            });
          }
        }; // Если элемент, на котором произошло событие, имеет класс js-accordion-head--parent


        if (this.classList.contains("js-accordion-head--parent")) {
          // Если этот элемент был уже активен
          if (this.classList.contains("js-accordion-head--active")) {
            activeHead = self;
            var activeParent = activeHead.closest(".js-accordion-parent");
            closeAccordion(activeParent);
            accordion.classList.remove("js-accordion--active");
          } else {
            activeHead = accordion.querySelector(".js-accordion .js-accordion-head--active");

            if (activeHead) {
              var activeParent = activeHead.closest(".js-accordion-parent");
              closeAccordion(activeParent);
            }

            currentHead = self;
            var currentParent = currentHead.closest(".js-accordion-parent");
            openAccordion(currentParent);
            accordion.classList.add("js-accordion--active");

            if (activeHead) {
              setTimeout(function () {
                itsoftApp.modules.animateScroll.callback(currentHead);
              }, 500);
            }
          }
        } else {
          // Если этот элемент был уже активен
          if (this.classList.contains("js-accordion-head--active")) {
            activeHead = self;
            closeAccordion();
            accordion.classList.remove("js-accordion--active");
          } else {
            activeHead = accordion.querySelector(".js-accordion .js-accordion-head--active");

            if (activeHead) {
              closeAccordion();
            }

            currentHead = self;
            openAccordion();
            accordion.classList.add("js-accordion--active");

            if (activeHead) {
              setTimeout(function () {
                itsoftApp.modules.animateScroll.callback(currentHead);
              }, 500);
            }
          }
        }
      });
    });
  };

  module.callback = initAccordions;
});
"use strict";

itsoftApp.createModule("animateScroll", ["windowResize", "pageLoad"], function () {
  var maxMobileWidth = 767;
  var module = this;
  var loaded = false;
  var pageHeader = document.querySelector("[data-fixed='true']");
  var viewportSize = itsoftApp.utils.getViewportSize();

  var getViewportSize = function getViewportSize() {
    viewportSize = itsoftApp.utils.getViewportSize();
  };

  var startScroll = function startScroll(target, padding) {
    var defaultPadding = 0;

    if (pageHeader) {
      if (!itsoftApp.commonVars.headerHeight) {
        itsoftApp.utils.getHeaderHeight();
      }

      if (target.hasAttribute("data-offset")) {
        if (viewportSize <= maxMobileWidth) {
          defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
        } else {
          defaultPadding = itsoftApp.commonVars.headerHeight + itsoftApp.commonVars.headerHeight / 2;
        }
      } else if (target.hasAttribute("data-offset-mobile") && viewportSize <= maxMobileWidth) {
        defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
      } else {
        defaultPadding = itsoftApp.commonVars.headerHeight;
      }
    }

    var settings = {
      offset: defaultPadding
    };
    var scroll = new SmoothScroll();

    if (!document.body.classList.contains("is-popup-opened")) {
      scroll.animateScroll(target, "auto", settings);
    } else {
      setTimeout(function () {
        scroll.animateScroll(target, "auto", settings);
      }, 800);
    }
  };

  var load = function load(target, padding) {
    if (!loaded) {
      window.noZensmooth = true;
      itsoftApp.loadScript("assets/scripts/smoothScroll/smooth-scroll.min.js", function () {
        loaded = true;
        startScroll(target, padding);
      });
    } else {
      startScroll(target, padding);
    }
  };

  var initAnimateScroll = function initAnimateScroll(el, padding) {
    el.addEventListener("click", function (evt) {
      evt.preventDefault();
      var scrollId = evt.currentTarget.href;

      if (!scrollId || !(scrollId = scrollId.split('#')[1])) {
        return;
      }

      var target = document.querySelector('#' + scrollId);
      load(target);
    });
  };

  var links = document.querySelectorAll("a[href^='#']:not([href='#'])");
  Array.prototype.forEach.call(links, function (el) {
    initAnimateScroll(el);
  });
  itsoftApp.modules.pageLoad.addEvent(function () {
    var hash = window.location.hash;
    var hashTo = hash.substring(1);

    if (hashTo.indexOf("to--") > -1) {
      var currentHash = hashTo.substring(hashTo.indexOf("to--") + 4);
      var currentElement = document.querySelector("#" + currentHash);
      load(currentElement);
      /* NOTE: Нужно будет удалить "псевдохэш", начинающийся на "to--", чтобы не вводить браузер в заблуждение */
    } // else {
    //   var currentElement = document.querySelector(hash);
    //   load(currentElement);
    // }

  });
  module.callback = load;
  itsoftApp.modules.windowResize.addEvent(getViewportSize);
});
"use strict";

itsoftApp.createModule("animations", function () {
  var module = this;
  var defaultOptions = {
    draw: function draw(progress) {
      elem.style.width = progress * 100 + '%';
    },
    timing: function timing(timeFraction) {
      return timeFraction;
    },
    duration: 1000
  };

  var animate = function animate(options) {
    var start = performance.now();
    requestAnimationFrame(function animate(time) {
      // timeFraction от 0 до 1
      var timeFraction = (time - start) / options.duration;

      if (timeFraction > 1) {
        timeFraction = 1;
      } // текущее состояние анимации


      var progress = options.timing(timeFraction);
      options.draw(progress);

      if (timeFraction < 1) {
        requestAnimationFrame(animate);
      }
    });
  };

  module.callback = animate;
});
"use strict";

/* globals Raven, $buoop, $buo, $buo_show */

/* eslint camelcase:0 */

/**
 * Ненавязчивая плашка, которая оповестит пользователя о том,
 * что его браузер устарел и нуждается в обновлении.
 * https://browser-update.org/
 *
 * NOTE: Для нормальных браузеров данная плашка, понятное дело, не отображается.
 * Но посмотреть, как она выглядит, можно, выполнив в консоли код:
 * $buo({}, true);
 */
itsoftApp.createModule("browserUpdate", ["pageLoad"], function () {
  // Локальные переменные
  var module = this;
  var isRavenOn = typeof window.Raven !== "undefined";
  /**
   * Запуск интервального таймера
   */

  var init = function init() {
    /**
     * Функция, которая будет вызываться с определённым интервалом
     * до тех пор, пока скрипты с сайта browser-update.org не загрузятся и не отработают.
     */
    var intervalFunc = function intervalFunc() {
      // Так как нет прямого метода, позволяющего определить, отработали или нет скрипты browser-update.org,
      // то определяем косвенно, по наличию некоторой глобальной переменной.
      if (typeof $buoop === "undefined") {
        return;
      } // Один раз определив момент, когда скрипты browser-update.org отработали,
      // отменяем интервальный таймер.


      clearInterval(interval); // Три разных косвенных способа проверить, была ли пользователю
      // показана плашка с предупреждением об устаревшем браузере:

      var barShown1 = !!document.getElementById("buorg");
      var barShown2 = $buoop.test;
      var barShown3 = typeof $buo_show !== "undefined"; // Необходимо, чтобы хотя бы один косвенный метод дал положительный результат,
      // тогда будем считать, что плашка, действительно, показана.

      var barShown = barShown1 || barShown2 || barShown3; // Если сам скрипт посчитал, что браузер не устаревший, хотя на самом деле
      // он не поддерживает некоторые функции, мы можем сами определить
      // дополнительные проверки, по результатам которых решим,
      // показывать или нет сообщение пользователю.

      var extaConditions = [];

      if (!barShown) {
        var fakeElem = document.createElement("div"); // Проверка, поддерживает ли браузер операции classList.add, classList.remove и т. п.
        // (проверку провалят браузеры на android 2.3.6 и аналогичные динозавры)

        if (!("classList" in fakeElem) || !("add" in fakeElem.classList)) {
          extaConditions.push("classList");
        } // Проверка, поддерживает ли браузер обработчик событий addEventListener
        // (проверку провалят старые IE)


        if (!("addEventListener" in document)) {
          extaConditions.push("addEventListener");
        } // Проверка, поддерживает ли браузер методы window.btoa и window.atob,
        // которые нужны для преобразований base64
        // (проверку провалят старые IE)


        if (itsoftApp.modules.base64 && itsoftApp.modules.base64.initialized === true) {
          extaConditions.push("base64");
        } // Если хотя бы одно из доп. условий сработало,
        // то показываем плашку с предложением обновить браузер.


        if (extaConditions.length > 0) {
          $buo({}, true); // Показать предупреждение (принудительно)

          barShown = true;
          DEBUG && console.log("[module browserUpdate] bar shown by additional conditions");
        }
      } // Создаём объект с параметрами, которые мы передадим в js-логгер


      var barShownMessage = barShown ? "shown" : "not shown";
      var extraContext = {};
      var key, value;

      for (key in $buoop) {
        value = $buoop[key];

        if ($buoop.hasOwnProperty(key) && typeof value !== "function") {
          extraContext[key] = value;
        }
      }

      if (extaConditions.length > 0) {
        extraContext["extraConditions"] = extaConditions.join(", ");
      } // Отправить сообщение в js-логгер
      // (только в том случае, если плашка показана)


      if (isRavenOn && barShown) {
        Raven.captureMessage("[module browserUpdate] old browser detected", {
          level: "info",
          // one of 'info', 'warning', or 'error'
          extra: extraContext
        });
      } // Передать в остальные модули, где будет происходить отправка
      // сообщений в логгер, параметр browserUpdateBar (показана плашка или нет).


      if (isRavenOn) {
        Raven.setExtraContext({
          browserUpdateBar: barShownMessage
        });
      }

      DEBUG && console.log("[module browserUpdate] object recieved. barShown: " + barShown + ". extraContext: ", extraContext);
      module.extraContext = extraContext;
      module.barShown = barShown;
    }; // Выполняем функцию с определённым интервалом,
    // так как загрузка скрипта //browser-update.org/update.min.js -
    // это не тот самый момент, когда отрабатывает сам скрипт.
    // Дело в том, что там дальше по цепочке грузится ещё один скрипт, вот почему
    // мы не можем чётко отследить момент, когда всё-таки у нас прошла проверка на устаревшие браузеры.
    // Функция будет выполняться до тех пор,
    // пока не появится объект $buoop - признак того, что проверка произведена.


    var interval = setInterval(intervalFunc, 100);
  };
  /**
   * Грузим первоначальный скрипт с сайта browser-update.org
   * (локальная версия - в качестве fallback'а),
   * после чего запускаем наш интервальный таймер,
   * ловим момент загрузки второго скрипта и т. д.
   */


  var load = function load() {
    itsoftApp.loadScript("//browser-update.org/update.min.js", "/assets/scripts/browser-update.min.js", function () {
      DEBUG && console.log("[module browserUpdate] script loaded");
      init();
    });
  }; // Делегируем функцию в модуль pageLoad
  // (откладываем выполнение до полной загрузки страницы)


  DEBUG && console.log("%c--[module browserUpdate] delegating load to pageLoad module", "font-style: italic; color: #999");
  itsoftApp.modules.pageLoad.addEvent(load);
});
"use strict";

itsoftApp.createModule("checkMenuLink", function () {
  var menuLinkElements = document.querySelectorAll(".main-menu__link");
  Array.prototype.forEach.call(menuLinkElements, function (el) {
    var href = el.href;

    if (el.pathname + el.hash === location.pathname) {
      var menuItem = el.parentNode;
      menuItem.classList.add("main-menu__item--current");
      el.removeAttribute("href");
    }
  });
});
"use strict";

itsoftApp.createModule("createScene", function () {
  var module = this;

  var initWebgl = function initWebgl() {
    var canvasContainer = document.getElementById("canvas-3d");
    var preloader = document.getElementById("canvas-preloader");

    if (canvasContainer) {
      itsoftApp.loadScript("/assets/scripts/three-js/three.min.js", function () {
        itsoftApp.loadScript("/assets/scripts/three-js/WebGL.js", function () {
          itsoftApp.loadScript("/assets/scripts/three-js/OrbitControls.min.js", function () {
            // "use strict";
            var isScroll = canvasContainer.classList.contains("js-scroll"); // перевод градусов в радианы

            var degToRadians = function degToRadians(deg) {
              return deg * Math.PI / 180;
            }; // // определяем начальные значения ширины и высоты холста


            var initialWidth = canvasContainer.clientWidth;
            var initialHeight = canvasContainer.clientHeight;
            /* Настройки для проецирования объектов на плоскость экрана: настройки 
                перспективы и глубины рендеринга, положение точки, из которой пользователь 
                смотрит на сцену хранятся в объекте Camera: */

            var params = {
              fov: 70,
              aspect: initialWidth / initialHeight,
              near: 1,
              far: 1000
            };

            var setup3dInfrastructure = function setup3dInfrastructure() {
              // функция для определения поведения холста и его содержимого при ресайзе
              function resize() {
                var canvas = renderer.domElement;
                var width = canvasContainer.clientWidth;
                var height = canvasContainer.clientHeight;
                if (height < 1 || width < 1) return; // 3.1. Camera resize

                if (width > height) {
                  this.camera.fov = 35;
                } else {
                  this.camera.fov = 32 * height / Math.min(width * 1.3, height);
                }

                this.camera.aspect = width / height;
                this.camera.updateProjectionMatrix(); // 3.3. Renderer resize

                this.renderer.setSize(width, height);
                return this;
              }
              /* Объект, отвечающий за рендеринг */


              var renderer = new THREE.WebGLRenderer({
                alpha: true,
                antialias: true
              });
              /* Здесь указываем следующее: каким цветом нужно очищать экран перед очередным циклом рендеринга,
              devicePixelRatio для различных экранов, чтобы картинка была чёткой, и размеры canvas. */

              renderer.setPixelRatio(window.devicePixelRatio);
              renderer.setSize(initialWidth, initialHeight);
              renderer.setClearColor(0x000000, 0);
              /* Чтобы можно было рендерить объекты на canvas в Three.js,
              необходимо описать их все и сгруппировать в специальном объекте Scene*/

              var scene = new THREE.Scene();
              /* Первый параметр — угол перспективы, второй — соотношение сторон canvas, третий и четвёртый параметры
              — наименьшее и наибольшее значения z-координаты, которые будут рендериться.*/

              var camera = new THREE.PerspectiveCamera(params.fov, params.aspect, params.near, params.far); // инфраструктра включает в себя рендерер, сцену, камеру

              var infrastructure = {
                renderer: renderer,
                scene: scene,
                camera: camera
              };
              infrastructure.resize = resize.bind(infrastructure);
              return infrastructure;
            };
            /* Добавление в DOM */


            var appendRendererToDOMElement = function appendRendererToDOMElement(renderer, targetNode) {
              targetNode.appendChild(renderer.domElement);
            };

            function start() {
              // проверяем поддержку WebGL браузером
              // var hasWebGLSupport = function () {
              //   return THREE.WEBGL.isWebGLAvailable() || THREE.WEBGL.isWebGL2Available();
              // }();
              // настраиваем инфраструктуру
              // Добавление препарата на сцену
              var infrastructure = setup3dInfrastructure();
              var distanceToCamera = 15;
              infrastructure.camera.position.z = distanceToCamera;
              var halfHeight = distanceToCamera / Math.tan(params.fov / 2 * Math.PI / 180);
              var textureWidth = 395;
              var textureHeight = 184;
              var bgTextureWidth = 827;
              var bgTextureHeight = 135;
              var xScale = 6.2;
              var yScale = xScale * textureHeight / textureWidth;
              var xBgScale = 13.1;
              var yBgScale = xBgScale * bgTextureHeight / bgTextureWidth;
              var objects = [];
              var map = new THREE.TextureLoader().load("/media/images/features-preparation.png");
              map.minFilter = THREE.LinearFilter;
              map.wrapS = THREE.ClampToEdgeWrapping;
              map.wrapT = THREE.ClampToEdgeWrapping;
              var spriteMaterial = new THREE.SpriteMaterial({
                map: map
              });
              var sprite = new THREE.Sprite(spriteMaterial);
              sprite.scale.x = xScale;
              sprite.scale.y = yScale;
              sprite.position.y = 0.26;
              infrastructure.scene.add(sprite); // фон для сцены
              // создание орбиты

              var bgMap = new THREE.TextureLoader().load("/media/images/features-ellipse.png");
              bgMap.minFilter = THREE.LinearFilter;
              map.wrapS = THREE.ClampToEdgeWrapping;
              map.wrapT = THREE.ClampToEdgeWrapping;
              var bgMaterial = new THREE.SpriteMaterial({
                map: bgMap
              });
              var bgSprite = new THREE.Sprite(bgMaterial);
              bgSprite.scale.x = xBgScale;
              bgSprite.scale.y = yBgScale;
              bgSprite.position.y = -0.5;
              infrastructure.scene.add(bgSprite);
              var light = new THREE.PointLight(0xffffff, 1, 0); // Specify the light's position

              light.position.set(1, 1, 100); // Add the light to the scene

              infrastructure.scene.add(light); // создание иконки и текста
              // 

              var count = 4;

              for (var i = 0; i < count; i++) {
                var xCircleScale = 0.84; //0.3;

                var textureCircleWidth = 90;
                var textureCircleHeight = 90;
                var yCircleScale = xCircleScale * textureCircleHeight / textureCircleWidth;
                var slideMap = new THREE.TextureLoader().load("/media/images/icon-item-" + (i + 1) + "@2x.png");
                var t = i / count * 2 * Math.PI;
                var wrapper = new THREE.Object3D(); // настройки интерполяции

                slideMap.minFilter = THREE.LinearFilter;
                slideMap.wrapS = THREE.ClampToEdgeWrapping;
                slideMap.wrapT = THREE.ClampToEdgeWrapping;
                var slideSpriteMaterial = new THREE.SpriteMaterial({
                  map: slideMap
                });
                var slideSprite = new THREE.Sprite(slideSpriteMaterial);
                wrapper.position.x = Math.cos(t) * 6.2;
                wrapper.position.z = Math.sin(t) * 6.2;
                slideSprite.scale.x = xCircleScale;
                slideSprite.scale.y = yCircleScale;
                wrapper.add(slideSprite);
                var xLabelScale = 2.7; //0.3;

                var textureLabelWidth = 286;
                var textureLabelHeight = 112;
                var yLabelScale = xLabelScale * textureLabelHeight / textureLabelWidth;
                var labelMap = new THREE.TextureLoader().load("/media/images/item-text-" + (i + 1) + ".png");
                labelMap.minFilter = THREE.LinearFilter;
                labelMap.wrapS = THREE.ClampToEdgeWrapping;
                labelMap.wrapT = THREE.ClampToEdgeWrapping;
                var labelSpriteMaterial = new THREE.SpriteMaterial({
                  map: labelMap
                });
                var labelSprite = new THREE.Sprite(labelSpriteMaterial); // wrapper.attach(labelSprite)

                labelSprite.position.y = -1; // wrapper.attach(labelSprite)
                // labelSprite.position.x = Math.cos(t) * 2;
                // labelSprite.position.z = Math.sin(t) * 2;

                labelSprite.scale.x = xLabelScale;
                labelSprite.scale.y = yLabelScale;
                wrapper.add(labelSprite);
                var object = {
                  slideSprite: slideSprite,
                  labelSprite: labelSprite
                }; // wrapper.add(label);

                infrastructure.scene.add(wrapper);
                objects.push(object);
              }

              if (!isScroll) {
                var controls = new THREE.OrbitControls(infrastructure.camera, infrastructure.renderer.domElement);
                controls.minPolarAngle = degToRadians(82);
                controls.maxPolarAngle = degToRadians(82);
                controls.enableZoom = false;
                controls.enableDamping = true;
                controls.rotateSpeed = 0.5;
                controls.autoRotate = true;
                controls.autoRotateSpeed = 0.2;
                controls.maxDistance = distanceToCamera;
                controls.minDistance = distanceToCamera;
                controls.keys = {
                  LEFT: "",
                  UP: "",
                  RIGHT: "",
                  BOTTOM: ""
                };
              } //


              var onEnterFrame = function onEnterFrame(infrastructure) {
                if (infrastructure.resizeInProgress) {
                  infrastructure.resize();
                }

                infrastructure.renderer.render(infrastructure.scene, infrastructure.camera);
                infrastructure.resizeInProgress = false;

                if (!isScroll) {
                  controls.update();
                }

                requestAnimationFrame(function () {
                  onEnterFrame(infrastructure);
                });
              };

              requestAnimationFrame(function () {
                onEnterFrame(infrastructure);
              }); //
              // Resize:

              infrastructure.resize();
              window.addEventListener("resize", function () {
                infrastructure.resizeInProgress = true;
              }); //
              // Add to DOM:

              appendRendererToDOMElement(infrastructure.renderer, canvasContainer);
            }

            start();
          });
        });
      });
    }

    ;
  };

  module.callback = initWebgl;
});
"use strict";

/**
 * Кнопки в левом нижнем углу экрана
 * (только в режиме dev)
 *
 * NOTE: Код подключается с доп. командой DEBUG && -
 * это значит, что при минификации скриптов
 * данный модуль будет целиком вырезан, и можно не париться насчёт лишних килобайтов.
 */
DEBUG && itsoftApp.createModule("devBtns", function () {
  if (!document.querySelector(".js-toggle-styles") && !document.querySelector(".js-toggle-images")) {
    return false;
  }
  /**
   * Отображение без стилей
   * (полезно для проверки чистой разметки, заголовков, секций и т. п.)
   */


  (function () {
    var btn = document.querySelector(".js-toggle-styles");

    if (!btn) {
      return false;
    }

    var toggled = false;
    var links = document.querySelectorAll("link");

    var btnClick = function btnClick() {
      var link, i, media;

      if (!toggled) {
        for (i = links.length - 1; i >= 0; i--) {
          link = links[i];
          media = link.getAttribute("media");

          if (!media) {
            continue;
          }

          link.setAttribute("data-media", media);
          link.setAttribute("media", "none");
        }

        toggled = true;
      } else {
        for (i = links.length - 1; i >= 0; i--) {
          link = links[i];
          media = link.getAttribute("data-media");

          if (!media) {
            continue;
          }

          link.setAttribute("media", media);
          link.removeAttribute("data-media");
        }

        toggled = false;
      }
    };

    btn.addEventListener("click", btnClick, false);
  })();
  /**
   * Отображение без изображений,
   * но так, чтобы был виден текст атрибута alt.
   */


  (function () {
    var btn = document.querySelector(".js-toggle-images");

    if (!btn) {
      return false;
    }

    var toggled = false;
    var dAttrSrcOri = "data-src-ori";
    var attrSrc = "src";
    var i, img;

    var btnClick = function btnClick() {
      var images = document.querySelectorAll("img");

      for (i = images.length - 1; i >= 0; i--) {
        img = images[i];

        if (!toggled) {
          img.setAttribute(dAttrSrcOri, img.getAttribute(attrSrc));
          img.removeAttribute(attrSrc);
        } else {
          img.setAttribute(attrSrc, img.getAttribute(dAttrSrcOri));
          img.removeAttribute(dAttrSrcOri);
        }
      }

      toggled = !toggled;
    };

    btn.addEventListener("click", btnClick, false);
  })();
});
"use strict";

itsoftApp.createModule("disclaimer", ["windowResize"], function () {
  var pageFooter = document.querySelector(".page-footer");
  var disclaimer = document.querySelector(".disclaimer");
  var disclaimerButton = document.querySelector(".disclaimer__close-button");
  var disclaimerConfirm = document.querySelector(".disclaimer__confirm");
  var lwrapper = document.querySelector(".l-wrapper");

  var buttonMouseOver = function buttonMouseOver(evt) {
    if (!disclaimer.classList.contains("js-hover")) {
      disclaimer.classList.add("js-hover");

      if (disclaimerConfirm) {
        disclaimerConfirm.addEventListener("mouseout", buttonMouseOut);
      }
    }
  };

  var buttonMouseOut = function buttonMouseOut(evt) {
    setTimeout(function () {
      disclaimer.classList.remove("js-hover");

      if (disclaimerConfirm) {
        disclaimerConfirm.removeEventListener("mouseout", buttonMouseOut);
      }
    }, 2000);
  };

  var disclaimerClose = function disclaimerClose() {
    disclaimer.classList.add("js-static");
    disclaimer.classList.add("js-inactive");

    if (disclaimer.classList.contains("js-hover")) {
      disclaimer.classList.remove("js-hover");
    }

    if (disclaimerConfirm) {
      disclaimerConfirm.style.display = "none";
    }

    pageFooter.classList.add("js-update");
  };

  disclaimerButton.addEventListener("mouseover", buttonMouseOver);

  if (disclaimerConfirm) {
    disclaimerConfirm.addEventListener("click", function (evt) {
      evt.preventDefault();
      disclaimerClose();
    });
  }

  disclaimerButton.addEventListener("click", function (evt) {
    evt.preventDefault();
    disclaimerClose();
  });
  var footerCoordY;

  var defineCoordY = function defineCoordY() {
    footerCoordY = pageFooter.getBoundingClientRect().top + pageYOffset;
  };

  var checkElementCoords = function checkElementCoords() {
    var s_top = pageYOffset;

    if (s_top + document.documentElement.clientHeight > footerCoordY) {
      disclaimerButton.classList.add("js-close-hide");
      disclaimer.classList.add("js-inactive");
    } else if (!disclaimer.classList.contains("js-static")) {
      disclaimerButton.classList.remove("js-close-hide");
      disclaimer.classList.remove("js-inactive");
    } else {
      document.removeEventListener("scroll", onDocumentScroll);
      window.removeEventListener("resize", onDocumentResize);
    }
  };

  var onDocumentScroll = function onDocumentScroll() {
    checkElementCoords();
  };

  var onDocumentResize = function onDocumentResize() {
    defineCoordY();
    checkElementCoords();
  };

  defineCoordY();
  checkElementCoords();
  document.addEventListener("scroll", onDocumentScroll);
  window.addEventListener("resize", onDocumentResize);
});
"use strict";

itsoftApp.createModule("lazyLoadingImages", function () {
  var module = this;

  var initLazy = function initLazy() {
    itsoftApp.loadScript("assets/scripts/lazysizes/lazysizes.min.js", function () {
      window.lazySizesConfig = window.lazySizesConfig || {};
    });
  };

  initLazy();
  module.callback = initLazy;
});
"use strict";

/**
 * Мобильное меню
 *
 * NOTE: Модуль можно удалить, если на сайте предусмотрено
 * принципиально иное меню для мобильных устройств.
 */
itsoftApp.createModule("mobMenu", ["windowScroll"], function () {
  var parentClass = "js-mobmenu";
  var parent = document.querySelector("." + parentClass);

  if (!parent) {
    return false;
  } // Локальные переменные


  var toggleBtns = document.querySelector(".js-mobmenu-toggle");
  var openedClass = "is-opened";
  var activeClass = "is-active";
  var opened = false;
  var $body = itsoftApp.commonVars.$body;
  var expandedBlocks = document.querySelector(".js-mobmenu-expand");
  var fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
  var getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
  var mainMenuLinks = document.querySelectorAll(".js-link");

  var openMenu = function openMenu() {
    if (opened) {
      return;
    }

    opened = true;

    if (fixedPageElems) {
      var scrollbarWidth = getScrollbarWidth();
      DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
      Array.prototype.forEach.call(fixedPageElems, function (el) {
        el.style = "padding-right:" + scrollbarWidth + "px";
      });
    }

    toggleBtns.classList.add(activeClass);
    parent.classList.add(openedClass);
    document.documentElement.style.overflow = 'hidden'; // NOTE: Отменил прокрутку

    DEBUG && console.log("[module mobMenu] menu opened");
  };

  var closeMenu = function closeMenu() {
    if (!opened) {
      return;
    }

    opened = false;

    if (fixedPageElems) {
      Array.prototype.forEach.call(fixedPageElems, function (el) {
        el.style = "padding-right: 0";
      });
    }

    document.documentElement.style.overflow = 'visible'; // NOTE: Вернул прокрутку

    toggleBtns.classList.remove(activeClass);
    parent.classList.remove(openedClass);
    DEBUG && console.log("[module mobMenu] menu closed");
  };

  var toggleBtnClick = function toggleBtnClick() {
    if (opened) {
      closeMenu();
    } else {
      openMenu();
    }
  };
  /**
   * Обработчик события пролистывания страницы.
   * Мы будем скрывать меню, если пользователь начал листать страницу вниз.
   *
   * @param  {number} y Текущее значение прокрутки страницы
   */


  var scrollController = function scrollController(y) {
    if (!opened) {
      return;
    } // Значение уже придёт нам из модуля itsoftApp.modules.windowScroll,
    // но на всякий случай пропишем fallback.


    y = typeof y === "number" ? y : document.body.scrollTop || document.documentElement.scrollTop;
    var menuHeight = parent.offsetHeight + expandedBlocks.offsetHeight;

    if (y > menuHeight + 20) {
      closeMenu();
    }
  };
  /**
   * Как и в случае со всплывашками на сайте,
   * для меню, если мы видим оставшуюся часть страницы, и кликаем по затемнённой области,
   * то пользователь интуитивно ожидает, что меню закроется.
   * Данный обработчик как раз для этого.
   *
   * @param  {object} e Event
   */


  var bodyClick = function bodyClick(e) {
    if (!opened) {
      return;
    }

    var target = e.target;
    var hasParent = target.closest("." + parentClass); // Закрываем меню, только если клик произошёл
    // по элементу вне пределов родительского блока
    // (по сути - клик по любой точке экрана, кроме меню).

    if (!hasParent) {
      closeMenu(); // Отмена действия по умолчанию
      // (например, чтобы не произошёл переход по ссылке, если
      // мы кликнули по элементу <a>).

      return false;
    }
  }; // Привязка событий и функций-обработчиков


  toggleBtns.addEventListener("click", toggleBtnClick);
  $body.addEventListener("click", bodyClick); // NOTE: Выловили нелепый баг, на айпадике.
  // Без строчки ниже не срабатывало событие click у верхнего элемента body.
  // Говно, дерьмо, жопа :D

  itsoftApp.commonVars.$wrapper.addEventListener("click", function () {});
  Array.prototype.forEach.call(mainMenuLinks, function (el) {
    el.addEventListener("click", function () {
      // if (currentOpenedPopup) {
      //     currentOpenedPopup.dispatchEvent(closeEvent);
      // }
      closeMenu();
    });
  }); // Делегируем функцию в модуль windowScroll
  // (единая точка входа для события "scroll").

  DEBUG && console.log("%c--[module mobMenu] delegating scrollController to windowScroll module", "font-style: italic; color: #999");
  itsoftApp.modules.windowScroll.addEvent(scrollController);
});
"use strict";

/**
 * Общая точка входа
 * для события полной загрузки страницы
 * (включая загрузку изображений, метрик и прочего).
 *
 * NOTE: Не путать с событием DOMContentLoaded
 * (оно же - $(document).ready(function() {...}) - в терминах jQuery).
 */
itsoftApp.createModule("pageLoad", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var singleFunctionFired = false;
  var timeoutInit = 120;
  var timeoutDelta = 80;
  var $window = itsoftApp.commonVars.$window;
  var flag = false;
  var body = document.body;
  /**
   * Функция, которая сработает лишь один раз,
   * и будет означать полную загрузку страницы.
   */

  var singleLoadFunction = function singleLoadFunction() {
    var readyState = document.readyState;
    var func, timeoutCurrent;

    if (readyState !== "complete" || singleFunctionFired || !events.length) {
      return false;
    }

    DEBUG && console.log("%c[module pageLoad] window load event fired, count of functions to init: " + events.length + ", timeout for first func: " + timeoutInit + ", timeout delta for other: " + timeoutDelta, "color: purple");

    while (events.length > 0) {
      // Взять первый элемент массива,
      // и передать его в переменную.
      func = events.shift(); // Будем запускать наши отложенные функции
      // через определённые промежутки времени, друг за другом с некоторым промежутком.
      // Мы уже знаем, что это функции,
      // поэтому доп. проверка не требуется.

      timeoutCurrent = timeoutCurrent ? timeoutCurrent + timeoutDelta : timeoutInit;
      setTimeout(func, timeoutCurrent);
    }

    singleFunctionFired = true;

    if (!flag) {
      $window.removeEventListener("load", singleLoadFunction);
      flag = true;
      body.classList.add("js-loaded");
    }
  }; // Привязка собитий и функции-обработчика


  if (document.readyState === "complete") {
    singleLoadFunction();
  } else {
    $window.addEventListener("load", singleLoadFunction);
  }
  /**
   * Добавление переданной функции в очередь на выполнение,
   * либо немедленное исполнение функции, если страница уже полностью загружена.
   *
   * @param {function} func
   */


  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    } // Если страница ещё не загружена полность, то добавляем в очередь


    if (!singleFunctionFired) {
      events.push(func);
      DEBUG && console.log("[module pageLoad] function added, count of functions to init now: " + events.length); // Если уже загружена, то просто вызываем переданную функцию
    } else {
      DEBUG && console.log("[module pageLoad] firing function immediately, because window load event already fired");
      func();
    }
  }; // Доступ к фукциям
  // текущего модуля


  module.addEvent = addEvent;
});
"use strict";

itsoftApp.createModule("parallaxMouse", function () {
  var TABLET_WIDTH = 1024;
  var scenes = document.querySelectorAll(".scene");
  var viewportSize = itsoftApp.utils.getViewportSize();
  var initialized = false;
  var module = this;

  var onWindowResize = function onWindowResize() {
    viewportSize = itsoftApp.utils.getViewportSize();

    if (scenes && viewportSize >= TABLET_WIDTH && !initialized) {
      initialized = true;
      initParallax();
      window.removeEventListener("resize", onWindowResize);
    }
  };

  var initParallax = function initParallax() {
    var loadParallax = function loadParallax(el) {
      var parallax = new Parallax(el);
    };

    itsoftApp.loadScript("/assets/scripts/parallax/parallax.min.js", function () {
      setTimeout(function () {
        for (var i = 0; i < scenes.length; i++) {
          if (scenes[i].classList.contains("scene--no-transition")) {
            scenes[i].classList.add("scene--active");
          }

          loadParallax(scenes[i], {
            relativeInput: true,
            clipRelativeInput: true
          });
        }
      }, 2700);
    });
  };

  var init = function init() {
    if (scenes && viewportSize >= TABLET_WIDTH && !initialized) {
      initialized = true;
      itsoftApp.modules.pageLoad.addEvent(initParallax);
    } else {
      window.addEventListener("resize", onWindowResize);
    }
  };

  module.callback = init;
});
"use strict";

/**
 * Всплывашки на сайте
 *
 * NOTE: Механизм, позволяющий отменить скролл для страницы, при открытой всплывашке,
 * достаточно хитрый, поэтому лучше изучить данный модуль, чтобы досконально понимать, как он работает
 */
itsoftApp.createModule("popups", function () {
  var BREAKPOINT = {
    mobile: 320,
    tablet: 768,
    desktop: 1280
  };
  var popupClass = "popup";
  var popups = document.querySelectorAll("." + popupClass);

  if (!popups.length) {
    return false;
  } // Локальные переменные


  var $body = document.body;
  var $document = document.documentElement;
  var $window = window;
  var $wrapper = document.querySelector(".l-wrapper");
  var activePopups = document.querySelectorAll("[data-bg-opened='true']");
  var openedClass = "is-opened";
  var dAttrSelector = "data-popup-selector";
  var dAttrBgClose = "data-bg-close";
  var hiddenClass = "g-hidden";
  var evNameOpen = "popups:open";
  var evNameClose = "popups:close";
  var wrapperAbsClass = "is-abs";
  var wrapperOverflow = "is-over";
  var popupOpenedClass = "is-popup-opened";
  var dAttrUrl = "data-url";
  var dAttrAutohide = "data-autohide";
  var dAttrHide = "data-hide";
  var dAttrClose = "data-close-popup";
  var popupBox = document.querySelector("#popup-box");
  var openPopupBtns = document.querySelectorAll(".js-open-popup");
  var closePopupBtns = document.querySelectorAll(".js-close-popup");
  var fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
  var hasFixedElems = fixedPageElems.length > 0;
  var hideDelayDefault = 3500;
  var staticBackUrl = window.location.pathname;
  var historyPushed = false;
  var autohidePopups = [].filter.call(popups, function (el) {
    return el.matches("[" + dAttrAutohide + "='true']");
  });
  var transitionEventEnd = itsoftApp.features.transitionEventEnd;
  var activeButton;
  /* ??? */

  var disabledButtons = document.querySelectorAll(".js-disabled");
  var confirmation = document.querySelector(".js-confirmation");
  var save = document.querySelector(".js-save");
  var date = 86400; // 24 часа

  var slider = {};
  window.currentOpenedPopup = undefined;
  var currentSlide;

  var getCookie = function getCookie(name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }; // Перемещаем все всплывашки в конец <body>.
  // Это нужно для того, чтобы при открытии всплывашки,
  // событие "scroll" всплывало до <body> и <html>,
  // но НЕ всплывало до <div class="l-wrapper">.
  // Это важно, так как при открытии всплывашки прокрутка
  // убирается у <body> и появляется у <div class="l-wrapper">.
  // Тем самым, мы "отменяем скролл".
  //
  // NOTE: На самом деле, отменить стандартный скролл браузера нельзя
  // (иначе не было бы всей этой истории).
  // Можно отменить, например, всплытие события "click" или действие по умолчанию для него.
  // Но ряд событий отменить или прервать всплытие нельзя.
  // popups.forEach(function (el) {
  //     var self = el;
  //     var idSelf = self.id;
  //     if (!popupBox.querySelector("#" + idSelf)) {
  //         popupBox.appendChild(self.classList.remove(hiddenClass));
  //     }
  // })
  // Вспомогательные функции


  var getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
  var getScrTop = itsoftApp.utils.getScrTop;

  var getOpenedPopups = function getOpenedPopups() {
    return [].filter.call(popups, function (el) {
      return el.classList.contains(openedClass);
    });
  };
  /**
   * Изменение адресной строки браузера при открытии всплывашки
   * (по необходимости).
   * Доп. инфа:
   * http://stackoverflow.com/questions/824349/modify-the-url-without-reloading-the-page
   *
   * @param  {string} url     Новый адрес
   * @param  {string} popupID Необходимо для отработки случая, когда мы перешли на страницу по прямому адресу
   */


  var changePageUrl = function changePageUrl(url, popupID) {
    // Если браузер не поддерживает работу с историей,
    // то прерываем выполнение функции.
    if (!window.history || typeof window.history.pushState !== "function" || typeof url !== "string") {
      DEBUG && console.log("%c[module popups] !window.history || typeof window.history.pushState != function || typeof url != string", "color: red");
      return;
    } // Переход "вперёд" по истории браузера ...


    if (url !== "back") {
      DEBUG && console.log("%c[module popups] trying to change page url to: " + url, "font-style: italic");
      window.history.pushState(false, false, url);
      historyPushed = true; // ... переход "назад"
    } else {
      // Случай, когда мы до этого открыли всплывашку и перешли "вперёд"
      if (historyPushed) {
        DEBUG && console.log("%c[module popups] trying to go back in history", "font-style: italic");
        window.history.back(); // Случай, когда до этого не было перехода "вперёд"
        // (например, пользователь перешёл по прямой ссылке).
      } else if (typeof popupID === "string") {
        var urlToChange = staticBackUrl;
        urlToChange = staticBackUrl.substring(0, staticBackUrl.length - popupID.length - 1);
        DEBUG && console.log("%c[module popups] replacing page url to " + urlToChange, "font-style: italic; color: orange");
        window.history.replaceState(false, false, urlToChange);
      }
    }
  };
  /**
   * Все действия, связанные с открытием всплывашки
   */


  var popupOpen = function popupOpen() {
    var self = this;

    if (self.classList.contains(openedClass)) {
      return;
    } // Если до этого уже были открыты всплывашки,
    // то вычисляем наибольший z-index, и присваиваем его
    // новой открывающейся всплывашке.
    // Иначе возможны ситуации, когда всплывашка открылась, но из-за расположения по вёрстке
    // оказалась ниже (за счет одинакового z-index), и в итоге её не видно.


    var openedPopups = getOpenedPopups();

    if (openedPopups.length > 0) {
      var maxZI = 0;
      Array.prototype.forEach.call(openedPopups, function (el) {
        var popup = el;

        if (popup.getAttribute("data-ignore") === "true") {
          return;
        }

        var zi = parseInt(getComputedStyle(popup)["zIndex"], 10);

        if (isNaN(zi)) {
          zi = 0;
        }

        maxZI = Math.max(maxZI, zi);
      });

      if (maxZI > 0) {
        self.style.zIndex = maxZI + 1;
        DEBUG && console.log("%c--[module popups] added z-index " + (maxZI + 1) + ", because there was another opened popups", "font-style: italic; color: #999");
      }
    } // Вычисляем текущую величину прокрутки страницы
    // (делаем это до того, как будут произведены какие-либо дальнейшие действия).


    var scrTop = getScrTop();
    DEBUG && console.log("[module popups] scrTop: " + scrTop); // Если есть fixed элементы на странице,
    // то задаём им padding-right, равный ширине полосы прокрутки.
    // Без этого такие элементы будут дёргаться,
    // так как в процессе открытия всплывашки слегка меняются общие стили страницы.

    if (hasFixedElems) {
      var scrollbarWidth = getScrollbarWidth();
      DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
      Array.prototype.forEach.call(fixedPageElems, function (el) {
        el.style.paddingRight = scrollbarWidth + "px";
      });
    } // NOTE: Это из-за плашки browser-update,
    // которая задаёт <html> ненулевой margin-top,
    // (в случае, если плашка об устаревшем браузере показана)
    // из-за которого страница "прыгает".


    var mt = parseInt(getComputedStyle($document)["marginTop"], 10);
    var mtExists = !isNaN(mt) && mt !== 0;

    if (mtExists) {
      scrTop -= mt;
    } // Основная магия происходит здесь.
    // Элементу .l-wrapper задаётся класс, который одновременно
    // убирает полосу прокрутки у <body> (так как .l-wrapper теперь position: absolute),
    // и добавляет полосу прокрутки у самого .l-wrapper (за счёт overflow: auto).
    // После этого остаётся прокрутить элемент .l-wrapper до того же значения,
    // которое было до этого у <body> (мы посчитали эту величину ранее).
    // Происходит это достаточно быстро, чтобы пользователь ничего не заметил.


    $wrapper.classList.add(wrapperAbsClass);
    $wrapper.scrollTop = scrTop; // NOTE: Это из-за плашки browser-update

    if (mtExists) {
      $document.scrollTop = 0;
    } // Это для отсутсвия скролла у <body> в некоторых редких случаях
    // (например, если висит плашка об устаревшем браузере)


    $body.classList.add(popupOpenedClass); // Здесь предусмотрена возможность автоматически скрывать некоторые всплывашки
    // при открытии других всплывашек.
    // Для этого им нужно задать определённый data- атрибут
    // (указан в локальных переменных в начале модуля).

    var autohidePopupsOpened = [].filter.call(autohidePopups, function (el) {
      return el.classList.contains("." + openedClass);
    });

    if (autohidePopupsOpened.length > 0) {
      DEBUG && console.log("[module popups] hided " + autohidePopupsOpened.length + " popups with " + dAttrAutohide + "=true");
      Array.prototype.forEach.call(autohidePopupsOpened, function (el) {
        el.classList.remove(openedClass);
      });
    }

    if (currentOpenedPopup) {
      currentOpenedPopup = undefined;
    } // Далее, делаем нашу всплывашку видимой (за счёт класса)


    self.classList.add(openedClass);
    currentOpenedPopup = self;
    isIncludeSlider = self.hasAttribute("data-slider");

    if (isIncludeSlider) {
      if (self.getAttribute("data-slider") !== "true") {
        var sliderContainer = self.querySelector(".js-slider");
        self.setAttribute("data-slider", "true");
        itsoftApp.modules.slidersLibrary.callback(sliderContainer, self.getAttribute("data-slider-name"), currentSlide);
      } else {
        itsoftApp.modules.slidersLibrary.slider[self.getAttribute("data-slider-name")].slideTo(+currentSlide);
      }
    }

    if (self.hasAttribute("data-destroy-device")) {
      var onWindowResize = function onWindowResize() {
        if (itsoftApp.utils.getViewportSize() >= BREAKPOINT[self.getAttribute("data-destroy-device")]) {
          self.dispatchEvent(closeEvent);
          window.removeEventListener("resize", onWindowResize);
        }
      };

      window.addEventListener("resize", onWindowResize);
    } // Здесь предусмотрена возможность
    // закрыть текущую всплывашку через определённый промежуток времени
    // (например, всплывашка с которким информационным сообщением).
    // Для этого им нужно задать определённый data- атрибут
    // (указан в локальных переменных в начале модуля).


    var hideDelay = self.getAttribute(dAttrHide);

    if (hideDelay) {
      hideDelay = parseInt(hideDelay, 10);
      hideDelay = isNaN(hideDelay) ? hideDelayDefault : hideDelay;
      setTimeout(function () {
        self.dispatchEvent(closeEvent);
      }, hideDelay);
    } // При необходимости, можно управлять адресной строкой браузера


    var urlToChange = self.getAttribute(dAttrUrl);

    if (urlToChange) {
      changePageUrl(urlToChange);
    }

    DEBUG && console.log("[module popups] opened popup: " + (self.id ? "#" + self.id : "." + self.className));
  };
  /**
   * Возврат страницы к исходному
   * (до того, как была открыта хоть одна всплывшка)
   * состоянию.
   *
   * @param  {boolean} force Часть функционала можно исполнить принудительно
   */


  var clearScrollStyles = function clearScrollStyles(force) {
    if (force == null) {
      force = false;
    } // Функция выполнится, если не осталось открытых всплывашек
    // (потому что их может быть несколько, и закрытие одной не означает закрытие всех),
    // либо принудительно (в редких случаях).


    var hasOpenedPopups = getOpenedPopups().length > 0;

    if (hasOpenedPopups && !force) {
      return;
    } // Вычисляем текущую величину прокрутки страницы
    // (функция getScrTop достаточно "умная", чтобы посчитать текущий скролл при любом состоянии).
    // Это нужно сделать до того, как произойдут дальнейшие действия.
    // $wrapper.classList.add(wrapperOverflow);


    var scrTop = getScrTop();
    DEBUG && console.log("%c[module popups] (clearScrollStyles) scrTop: " + scrTop + ". force: " + force, "color: #999"); // $wrapper.classList.remove(wrapperOverflow);
    // Возвращаем структурные элементы .l-wrapper и body
    // к исходному состоянию, убираем все необходимые классы.

    $wrapper.classList.remove(wrapperAbsClass);
    $body.classList.remove(popupOpenedClass); // Если на странице есть fixed элементы,
    // то убираем ранее заданное значение radding-right

    if (hasFixedElems) {
      Array.prototype.forEach.call(fixedPageElems, function (el) {
        el.style.paddingRight = "";
      });
    } // NOTE: Это из-за плашки browser-update


    var mt = parseInt(getComputedStyle($document)["marginTop"], 10);
    var mtExists = !isNaN(mt) && mt !== 0;

    if (mtExists) {
      scrTop += mt;
    } // // Наконец, пролистываем body до того значения,
    // // который был у .l-wrapper.
    // // Происходит это довольно быстро, так что пользователь не заметит разницы.


    $document.scrollTop = scrTop;
  };
  /**
   * Все действия, связанные с закрытием всплывашки
   */


  var popupClose = function popupClose() {
    var self = this;

    if (!self.classList.contains(openedClass)) {
      return;
    }

    if (activeButton) {
      /* ??? */
      activeButton.classList.remove("js-active");
      activeButton = undefined;
    }
    /* ??? */


    self.classList.remove(openedClass); // Так как вплывашка прилетает не мгновенно, а плавно,
    // то сразу делать возврат страницы к исходному состоянию нельзя
    // (будут видны артефакты, сязанные с переводом полосы прокрутки
    // от body к .l-wrapper и обратно).

    var end = function end() {
      setTimeout(function () {
        clearScrollStyles();
      }, 200);

      if (transitionEventEnd) {
        self.removeEventListener(transitionEventEnd, end);
      }
    }; // Для современных браузеров, где работает свойство transition,
    // вешаем обработчик на событие transitionEnd.


    if (transitionEventEnd) {
      self.addEventListener(transitionEventEnd, end); // Для старых браузеров, сразу вызываем функцию.
    } else {
      end();
    } // При необходимости,
    // меняем (возвращаем обратно)
    // адрес в строке браузера.


    var urlToChange = self.getAttribute(dAttrUrl);
    var popupID = self.id;

    if (urlToChange) {
      changePageUrl("back", popupID);
    }

    DEBUG && console.log("[module popups] closed popup: " + (self.id ? "#" + self.id : "." + self.className));
  };
  /**
   * Обработчик события "click", который определяет,
   * по какому именно мы кликнули элементу, и, если это
   * "пустое пространство" за самой всплывахой,
   * то закрываем её.
   *
   * NOTE: Можно отменить данное действие, задав дополнительный data- атрибут
   *
   * @param  {object} e Event
   */


  var popupClick = function popupClick(evt) {
    var self = this;

    if (evt.target === self && self.getAttribute(dAttrBgClose) !== "false") {
      self.dispatchEvent(closeEvent);
    }
  };
  /**
   * Клик по кнопкам, открывающим всплывахи.
   * Какую именно всплывашку открыть - обозначено в data- атрибуте.
   */


  var openPopupBtnClick = function openPopupBtnClick(evt) {
    evt.preventDefault();
    var self = this;
    var dataSlide = self.getAttribute("data-slide");
    var selector = self.getAttribute(dAttrSelector);
    var popup = [].filter.call(popups, function (el) {
      return el.matches(selector);
    })[0];
    dataSlide ? currentSlide = dataSlide : currentSlide = undefined;
    popup.dispatchEvent(openEvent);
    var closePopupSelector = self.getAttribute(dAttrClose);
    activeButton = this;
    /* ??? */

    if (closePopupSelector) {
      var popupToClose = document.querySelectorAll(closePopupSelector);
      /* ??? all*/

      Array.prototype.forEach.call(popupToClose, function (el) {
        el.dispatchEvent(closeEvent);
      });
    }
  };
  /**
   * Клик по кнопкам, закрывающим всплывашку.
   * Будет закрыта "родительская" всплывашка
   * (поиск по ближайшему родителю с нужным классом).
   */


  var closePopupBtnClick = function closePopupBtnClick() {
    var self = this;
    var popup = self.closest("." + popupClass);

    if (this.classList.contains("js-save")) {
      if (self.hasAttribute("data-checkbox")) {
        var checkboxID = self.getAttribute("data-checkbox");
        var checkbox = confirmation.querySelector(checkboxID);

        if (!checkbox.checked) {
          checkbox.classList.add("js-unmarked");
          return;
        }
      }

      var dAttrSave = this.getAttribute("data-save");
      document.cookie = dAttrSave + "=yes; path=/; max-age=" + date;
    }

    popup.dispatchEvent(closeEvent);
  };
  /**
   * Так как прокрутку страницы мы "отменяем" хитрым способом,
   * то при попытке перезагрузить страницу, на которой уже открыта всплывашка,
   * нас перекинет наверх страницы.
   * Это подбешивает, поэтому привязываем данную функцию на событие закрытия (обновления)
   * страницы. Мы принудительно возвращаем страницу к её исходному состоянию,
   * тем самым нас не перекинет наверх после перезагрузки.
   */


  var windowUnload = function windowUnload() {
    clearScrollStyles(true);
  };
  /**
   * Обработчик нажатий на кнопки клавиатуры.
   * Необходим для того, чтобы можно было закрыть всплывашку кнопкой ESC.
   *
   * NOTE: Так как возможны случаи, когда открыто несколько всплывах,
   * то закрываем их одна за одной, начиная с той, у которой наибольший z-index.
   *
   * @param  {object} e Event
   */


  var keyController = function keyController(evt) {
    // Обрабатываем только нажатие на ESC,
    // а все остальные нажатия игнорируем.
    if (evt.keyCode !== 27) {
      return;
    }

    var openedPopups = getOpenedPopups();

    if (!openedPopups.length) {
      return;
    }

    var maxZI = 0;
    var lastOpenedPopup = undefined;
    Array.prototype.forEach.call(openedPopups, function (el) {
      var popup = el;
      var zi = parseInt(getComputedStyle(popup)["zIndex"], 10);

      if (isNaN(zi)) {
        zi = 0;
      }

      if (zi >= maxZI) {
        maxZI = zi;
        lastOpenedPopup = popup;
      }
    });

    if (!lastOpenedPopup) {
      return;
    } // Закрываем только последнюю открытую всплывашку


    lastOpenedPopup.dispatchEvent(closeEvent);
  };

  if (window.CustomEvent && typeof window.CustomEvent === "function") {
    window.closeEvent = new CustomEvent(evNameClose, {
      detail: {
        name: "Закрытие"
      }
    });
    window.openEvent = new CustomEvent(evNameOpen, {
      detail: {
        name: "Открытие"
      }
    });
  } else {
    window.closeEvent = document.createEvent("CustomEvent");
    window.openEvent = document.createEvent("CustomEvent");
    closeEvent.initCustomEvent(evNameClose, true, true, {
      name: "Закрытие"
    });
    openEvent.initCustomEvent(evNameOpen, true, true, {
      name: "Открытие"
    });
  }

  Array.prototype.forEach.call(popups, function (popup) {
    popup.addEventListener(evNameOpen, popupOpen);
    popup.addEventListener(evNameClose, popupClose);
    popup.addEventListener("click", popupClick);
  });
  Array.prototype.forEach.call(openPopupBtns, function (openBtn) {
    openBtn.addEventListener("click", openPopupBtnClick);
  });
  Array.prototype.forEach.call(closePopupBtns, function (closeBtn) {
    closeBtn.addEventListener("click", closePopupBtnClick);
  });
  window.addEventListener("beforeunload", windowUnload);
  window.addEventListener("keyup", keyController);

  if (activePopups) {
    Array.prototype.forEach.call(activePopups, function (el) {
      var dAttrSave = el.getAttribute("data-save");

      if (dAttrSave && !(getCookie(dAttrSave) == "yes")) {
        el.dispatchEvent(openEvent);
      } else if (!dAttrSave) {
        el.dispatchEvent(openEvent);
      }
    });
  }

  if (disabledButtons) {
    Array.prototype.forEach.call(disabledButtons, function (el) {
      el.addEventListener("click", function (evt) {
        evt.preventDefault();
        confirmation.style.display = "none";
      });
    });
  } // Unit-tests


  if (DEBUG && typeof describe === "function") {
    describe("[module popups]", function () {
      it("all popups must be moved on <body> level", function () {
        popups.each(function () {
          expect(this.parentElement.nodeName.toLowerCase()).to.be.equal("body");
        });
      });
      it("each popup must have custom events: " + evNameOpen + " and " + evNameClose, function () {
        popups.each(function () {
          var obj = $._data(this, "events");

          expect(evNameOpen in obj).to.be.equal(true);
          expect(evNameClose in obj).to.be.equal(true);
        });
      });
    });
  }
});
"use strict";

itsoftApp.createModule("scrollAnimate", ["scrollEffects"], function () {
  var ScrollEffects = itsoftApp.modules.scrollEffects.ScrollEffects,
      fadeInElements = document.querySelectorAll(".fadeIn"),
      elementsInvisible = document.querySelectorAll(".js-invisible"); //анимация fadeIn элементов

  var initAnimation = function initAnimation() {
    for (var i = 0; i < fadeInElements.length; i++) {
      new ScrollEffects(fadeInElements[i], "fadeIn--show");
    }

    for (var j = 0; j < elementsInvisible.length; j++) {
      new ScrollEffects(elementsInvisible[j], "js-visible", "js-invisible");
    }
  };

  itsoftApp.modules.pageLoad.addEvent(initAnimation);
});
"use strict";

itsoftApp.createModule("scrollEffects", ["windowScroll"], function () {
  var module = this;
  var webglInitialized = false;
  var parallaxInitialized = false;
  var videoSectionInitialized = false;

  function ScrollEffects(self, classAnimate, oldClass, obj, callBack) {
    this._self = self;
    this._classAnimate = classAnimate;
    this._obj = obj, this._callBack = callBack;
    this._scrollPoint;
    this._oldClass = oldClass;
    this.init();
  }

  ScrollEffects.prototype.init = function () {
    var self = this;

    function show(scroll, number) {
      var scrolled = pageYOffset;
      var coeff;

      if (number) {
        coeff = number;
      } else {
        coeff = 1.3;
      }

      self._scrollPoint = parseInt(self._self.getBoundingClientRect().top); // console.log(scrolled + window.innerHeight / 2  + " " + (self._scrollPoint + scrolled));

      if (scrolled + window.innerHeight / coeff >= self._scrollPoint + scrolled) {
        self.fadeIn();
      }
    }

    show("auto", 1);
    itsoftApp.modules.windowScroll.addEvent(show);
  };

  ScrollEffects.prototype.fadeIn = function () {
    if (typeof this._callBack === "function") {
      this._callBack.call(this._obj);
    } else {
      if (this._oldClass) {
        this._self.classList.remove(this._oldClass);

        if (this._self.classList.contains("js-webgl") && !webglInitialized) {
          webglInitialized = true;
          setTimeout(function () {
            itsoftApp.modules.createScene.callback();
          }, 1000);
        }

        if (this._self.classList.contains("js-tabs-section")) {
          itsoftApp.modules.toggleTabs.callback(this._self);
        }

        if (this._self.classList.contains("js-accordion")) {
          itsoftApp.modules.accordion.callback(this._self);
        }

        if (this._self.classList.contains("js-parallax-mouse")) {
          itsoftApp.modules.parallaxMouse.callback();
        }

        this._oldClass = undefined;
      }

      this._self.classList.add(this._classAnimate);
    }
  };

  module.ScrollEffects = ScrollEffects;
});
"use strict";

/**
 * Общий модуль для всех лисалок на сайте.
 * Библиотека загружается по мере необходимости.
 */
itsoftApp.createModule("slidersLibrary", function () {
  // Локальные переменные
  var module = this;
  var queue = [];
  var libraryLoaded = false;
  var loadingStarted = false;
  /**
   * Вызов всех функций, которые были добавлены
   * в массив queue в процессе загрузки библиотеки
   * (до этого момента их вызов привёл бы к ошибке).
   */

  var initQueue = function initQueue() {
    if (!libraryLoaded) {
      return false;
    }

    var qLen = queue.length;

    if (!qLen) {
      return;
    }

    DEBUG && console.log("[module slidersLibrary] initQueue function fired, queue.length: " + qLen);

    while (queue.length > 0) {
      // Взять первый элемент массива,
      // и вызвать его. Мы уже знаем, что это функция,
      // поэтому доп. проверка не требуется.
      queue.shift()();
    }
  };
  /**
   * Загрузить библиотеку и выполнить
   * отложенные функции из массива queue.
   */


  var loadAndInit = function loadAndInit() {
    var f = function f() {
      libraryLoaded = true;
      initQueue();
    }; // Случай, если библиотека вдруг уже загружена
    // (например, если она принудительна вставлена в html через <script>)


    itsoftApp.loadStyle("assets/scripts/swiper/swiper.min.css");
    itsoftApp.loadScript("assets/scripts/swiper/swiper.min.js", function () {
      DEBUG && console.log("[module slidersLibrary] library loaded, ready to init queue");
      f();
    });
  };
  /**
   * Добавление переданной функции в очередь на выполнение,
   * либо немедленное исполнение функции, если библиотека уже загружена.
   *
   * @param {function} func
   */


  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    } // Если библиотека ещё не загружена, то добавляем в очередь


    if (!libraryLoaded) {
      // Если библиотека ещё не начала грузиться, то загружаем её
      // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
      if (!loadingStarted) {
        loadingStarted = true;
        DEBUG && console.log("%c--[module slidersLibrary] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
        itsoftApp.modules.pageLoad.addEvent(loadAndInit);
      }

      queue.push(func);
      DEBUG && console.log("[module slidersLibrary] function added, count of functions to init now: " + queue.length); // Если библиотека уже загружена, то просто вызываем переданную функцию
    } else {
      func();
    }
  }; // Доступ к функциям
  // текущего модуля


  module.addEvent = addEvent;

  var setSlider = function setSlider(el, name, currentSlide) {
    var createSlider = function createSlider() {
      var BREAKPOINT = {
        mobile: 320,
        tablet: 768,
        "tablet-max": 1024,
        desktop: 1280
      };
      var navigation = el.querySelector(".js-navigation");
      var pagination = el.querySelector(".js-pagination");
      var slideCount = el.getAttribute("data-slide-count");
      var dataDevice = el.getAttribute("data-destroy-device");
      var freeMode = el.getAttribute("data-free-mode");
      var dataGap = el.getAttribute("data-gap");
      var isInitialized = false;
      var initializedSlider;

      if (name) {
        var sliderName = name;
      }

      var sliderSettings = {
        slidesPerView: "auto",
        watchOverflow: true,
        a11y: {
          firstSlideMessage: "",
          lastSlideMessage: ""
        }
      };

      var destroySlider = function destroySlider() {
        initializedSlider.destroy(false, true);
        initializedSlider = undefined;
        isInitialized = false;
      };

      var initSlider = function initSlider() {
        initializedSlider = new Swiper(el, sliderSettings);

        if (initializedSlider) {
          if (sliderName) {
            module.slider[sliderName] = initializedSlider;
          }

          if (currentSlide) {
            initializedSlider.slideTo(+currentSlide);
          }

          isInitialized = true;
        }
      };

      var onWindowResize = function onWindowResize() {
        if (itsoftApp.utils.getViewportSize() >= BREAKPOINT[dataDevice]) {
          if (isInitialized === true) {
            destroySlider();
          }
        } else {
          if (isInitialized === false) {
            initSlider();
          }
        }
      };

      if (navigation) {
        var prevBtn = navigation.querySelector(".js-prev-btn");
        var nextBtn = navigation.querySelector(".js-next-btn");
        sliderSettings.navigation = {};
        sliderSettings.navigation.prevEl = prevBtn;
        sliderSettings.navigation.nextEl = nextBtn;
      }

      if (pagination) {
        sliderSettings.pagination = {};
        sliderSettings.pagination.el = ".js-pagination";
        sliderSettings.pagination.type = "fraction";

        sliderSettings.pagination.renderFraction = function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>' + '/' + '<span class="' + totalClass + '"></span>';
        };
      }

      if (freeMode) {
        sliderSettings.freeMode = true;
      }

      if (slideCount) {
        sliderSettings.slidesPerView = slideCount;
      }

      if (dataGap) {
        sliderSettings.spaceBetween = +dataGap;
        sliderSettings.slidesPerView = "auto";
      }

      if (dataDevice) {
        onWindowResize();
        itsoftApp.modules.windowResize.addEvent(onWindowResize);
      } else {
        initSlider();
      }
    };

    if (el.hasAttribute("data-delay")) {
      setTimeout(function () {
        addEvent(createSlider);
      }, +el.getAttribute("data-delay"));
    } else {
      addEvent(createSlider);
    }
  };

  module.slider = {};
  module.callback = setSlider;
});
"use strict";

itsoftApp.createModule("toggleTabs", function () {
  var module = this;
  var tabs = document.querySelectorAll('.js-tabs-section');

  var deletePopupHandler = function deletePopupHandler(el) {
    if (el.classList.contains("js-open-popup")) {
      el.classList.remove("js-open-popup");
      el.removeAttribute("data-popup-selector");
    }
  };

  var initTabToggle = function initTabToggle(tabs) {
    var tabs = tabs;
    var tabsContents = tabs.querySelectorAll(".js-tab-content");
    var tabsItems = tabs.querySelectorAll(".js-tab-name");
    var currentActiveTab = tabs.querySelector(".js-tab-name--active");
    var currentActiveContent = tabs.querySelector(".js-tab-content--active");
    var currentIndex;
    var hash = location.hash;
    var animationFlag = false;

    var goToHash = function goToHash(newHash) {
      var element;
      var contentElement;

      if (newHash) {
        var selector = "[data-tab-selector='" + newHash + "']";
        var contentSelector = "[data-content-url='" + newHash + "']";
        element = tabs.querySelector(selector);
        contentElement = tabs.querySelector(contentSelector);
      } else {
        element = tabsItems[0];
        contentElement = tabsContents[0];
      }

      if (element) {
        goToTab(element, contentElement);
      }
    };

    var goToTab = function goToTab(tab, content) {
      deletePopupHandler(tab); // currentActiveTab.classList.remove("js-tab-name--active");
      // currentActiveContent.classList.remove("js-tab-content--active");
      // currentActiveTab = tab;
      // currentActiveContent = content;
      // currentActiveTab.classList.add("js-tab-name--active");
      // currentActiveContent.classList.add("js-tab-content--active");

      var onCurrentActiveShowTransitionEnd = function onCurrentActiveShowTransitionEnd() {
        currentActiveContent.removeEventListener("transitionend", onCurrentActiveShowTransitionEnd);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            currentActiveContent.classList.remove("js-content-show");
            animationFlag = false;
          });
        });
      };

      var onActiveHideTransitionEnd = function onActiveHideTransitionEnd() {
        currentActiveContent.removeEventListener("transitionend", onActiveHideTransitionEnd);
        currentActiveTab.classList.remove("js-tab-name--active");
        currentActiveContent.classList.remove("js-tab-content--active");
        currentActiveContent.classList.remove("js-content-hide");
        currentActiveTab = tab;
        currentActiveContent = content;
        currentActiveTab.classList.add("js-tab-name--active");
        currentActiveContent.addEventListener("transitionend", onCurrentActiveShowTransitionEnd);
        currentActiveContent.classList.add("js-content-show");
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            currentActiveContent.classList.add("js-tab-content--active");
          });
        });
      };

      if (!content.classList.contains("js-tab-content--active") && animationFlag === false) {
        animationFlag = true;
        currentActiveContent.addEventListener("transitionend", onActiveHideTransitionEnd);
        currentActiveContent.classList.add("js-content-hide");
      }
    };

    var onTabClick = function onTabClick(evt, index) {
      if (evt.target.hasAttribute("data-tab-selector")) {
        location.hash = evt.target.getAttribute("data-tab-selector");
      } else if (evt.currentTarget.hasAttribute("data-tab-selector")) {
        location.hash = evt.currentTarget.getAttribute("data-tab-selector");
      }

      currentIndex = index;
      goToTab(tabsItems[currentIndex], tabsContents[currentIndex]);
    };

    var addTabClickListener = function addTabClickListener(tab, index) {
      tab.addEventListener("click", function (evt) {
        evt.preventDefault();
        onTabClick(evt, index);
      });
    };

    for (var i = 0; i < tabsItems.length; i++) {
      addTabClickListener(tabsItems[i], i);
    }

    if (location.hash) {
      goToHash(location.hash);
    } else {
      deletePopupHandler(tabsItems[0]);
    }

    module.callback.goToHash = goToHash;
  };

  var initTabs = function initTabs() {
    if (tabs) {
      for (var i = 0; i < tabs.length; i++) {
        initTabToggle(tabs[i]);
      }
    }
  };

  module.callback = initTabs;
});
"use strict";

/**
 * Общая точка входа
 * для события изменения размеров экрана.
 *
 * NOTE: Событие на практике происходит редко
 * (например, поворот планшета или телефона, или равзернуть окно на полный экран на десктопе),
 * поэтому мы будем "выполнять" его с помощью debouncer
 * (отложенное выполнение).
 */
itsoftApp.createModule("windowResize", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var $window = itsoftApp.commonVars.$window;
  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   *
   * Вызываем обработчик через debouncer (задержка по выполнению),
   * чтобы функции из массива не вызывались слишком часто.
   */

  var resizeController = itsoftApp.utils.debouncer(function () {
    if (!events.length) {
      return;
    }

    var f, i, len;

    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f();
    }
  });
  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "resize" окна браузера.
   *
   * @param {function} func
   */

  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }

    events.push(func);
    DEBUG && console.log("[module windowResize] function added, count of functions to init now: " + events.length);
  }; // Привязка события и обработчика


  $window.addEventListener("resize", resizeController); // Доступ к фукциям
  // текущего модуля

  module.addEvent = addEvent;
});
"use strict";

/**
 * Общая точка входа
 * для события скролла страницы.
 *
 * NOTE: Контроллер будет передавать текущее значение скролла
 * каждой из переданных в данный модуль функций.
 */
itsoftApp.createModule("windowScroll", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var enabled = false;
  var $window = itsoftApp.commonVars.$window;
  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   */

  var scrollController = function scrollController() {
    if (!enabled) {
      return;
    }

    var y = document.body.scrollTop || document.documentElement.scrollTop;
    var f, i, len;

    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f.call(this, y);
    }
  };
  /**
   * Привязка события и контроллера.
   * Вынесено в отдельную функцию, так как если модулю не передана ни одна функция на событие "scroll"
   * то и общий обработчик вешать нет смысла.
   * Сделано для оптимизации производительности (небольшая прибавка).
   */


  var bind = function bind() {
    $window.addEventListener("scroll", scrollController);
  };
  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "scroll".
   *
   * @param {function} func
   */


  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }

    if (!enabled) {
      enabled = true;
      bind();
    }

    events.push(func);
    DEBUG && console.log("[module windowScroll] function added, count of functions to init now: " + events.length);
  }; // Доступ к фукциям
  // текущего модуля


  module.addEvent = addEvent;
});